import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const Page403Icon = (props: any) => (
  <svg width={165} height={164} fill="none" {...props}>
    <path
      fill="#F0F6FE"
      d="M83.537 143.5c34.84 0 63.038-27.554 63.038-61.55 0-33.995-28.198-61.45-63.037-61.45C48.8 20.5 20.5 48.054 20.5 82.05c0 33.996 28.3 61.45 63.037 61.45Z"
    />
    <path
      fill="#2262CD"
      d="M112.384 143.046c-9.454.297-20.82 0-28.866-.099-7.945.297-19.411.396-28.866.099 9.354-5.244 12.673-15.038 13.076-21.468h31.38c.704 6.331 4.023 16.224 13.276 21.468Z"
    />
    <g filter="url(#a)">
      <path
        fill="#fff"
        d="M142.758 39.662v80.827c0 2.078-1.609 3.562-3.419 3.562H28.301c-1.911 0-3.42-1.583-3.42-3.562V39.662c0-1.88 1.61-3.562 3.42-3.562h110.837c2.112.099 3.62 1.682 3.62 3.562Z"
      />
    </g>
    <path
      fill="#4388FF"
      d="M142.494 39.186v71.222H24.619V39.186c0-1.94 1.65-3.603 3.439-3.603h110.86c2.063 0 3.576 1.663 3.576 3.603Z"
    />
    <path fill="#fff" d="M138.256 40.708H28.719v65.6h109.675v-65.6h-.138Z" />
    <path
      fill="#EAEEF9"
      d="M33.391 45.467h33.964v25.488H33.391zM75.441 45.467h56.607v10.354H75.441zM75.441 76.531h56.607v10.354H75.441zM75.441 59.804h56.607v4.779H75.441zM75.441 90.868h56.607v4.779H75.441zM33.391 76.531h33.964v25.488H33.391z"
    />
    <path
      fill="#D6DDE8"
      d="M83.619 119.203c1.61 0 2.917-1.187 2.917-2.869 0-1.583-1.207-2.869-2.917-2.869-1.61 0-2.917 1.187-2.917 2.869 0 1.583 1.207 2.869 2.917 2.869Z"
    />
    <path
      stroke="#256BE5"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M2.05 143.244h158.913"
    />
    <path
      fill="#F0F6FE"
      d="M13.219 74.517c2.313 0 4.124-1.781 4.124-4.056 0-2.276-1.81-4.057-4.124-4.057-2.313 0-4.124 1.781-4.124 4.056 0 2.276 1.911 4.057 4.124 4.057ZM9.095 61.359c1.51 0 2.817-1.286 2.817-2.77s-1.308-2.77-2.817-2.77c-1.508 0-2.816 1.286-2.816 2.77 0 1.583 1.308 2.77 2.816 2.77ZM156.644 84.707c2.916 0 5.23-2.275 5.23-5.145 0-2.869-2.314-5.144-5.23-5.144-2.917 0-5.23 2.275-5.23 5.144 0 2.87 2.313 5.145 5.23 5.145Z"
    />
    <path
      fill="#629BFF"
      d="M109.531 73.833c0 3.442-.583 6.599-1.894 9.611-2.912 7.46-9.175 13.198-16.895 15.78-2.621.861-5.389 1.291-8.302 1.291-15.001 0-27.09-11.907-27.09-26.682 0-14.776 12.089-26.683 27.09-26.683 15.002 0 27.091 12.05 27.091 26.683Z"
    />
    <path
      fill="#fff"
      d="M87.929 70.021v-5.285c0-2.883-2.502-5.286-5.504-5.286-1.501 0-2.836.64-4.003 1.602-1.001.96-1.668 2.242-1.668 3.844v5.285c-1.501.961-2.669 2.082-3.67 3.684a10.082 10.082 0 0 0-1.334 4.965c0 5.606 4.67 10.09 10.508 10.09 5.838 0 10.508-4.484 10.508-10.09.166-3.844-1.835-7.047-4.837-8.809Zm-4.337 9.77v2.723c0 .32-.333.64-.667.64h-1.168c-.333 0-.667-.32-.667-.64v-2.722c-1-.481-1.5-1.603-1.334-2.724.167-.96 1-1.761 2.001-1.922 1.668-.32 3.17.961 3.17 2.403 0 .96-.5 1.762-1.335 2.242ZM85.26 68.9c-1-.32-1.835-.48-3.002-.48-1 0-2.002.16-3.002.48v-4.004c0-.801.333-1.602.834-2.082.5-.48 1.334-.801 2.168-.801 1.668 0 3.002 1.281 3.002 2.883V68.9Z"
    />
    <defs>
      <filter
        id="a"
        width={161.877}
        height={131.951}
        x={2.881}
        y={25.1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_11513_169428"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_11513_169428"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export const UnionIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aUnionIcon)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.25 4a1 1 0 0 0-1-1h-.5a1 1 0 0 0-1 1v6.25a.5.5 0 0 1-.5.5H4a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h6.25a.5.5 0 0 1 .5.5V20a1 1 0 0 0 1 1h.5a1 1 0 0 0 1-1v-6.25a.5.5 0 0 1 .5-.5H20a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-6.25a.5.5 0 0 1-.5-.5V4Z"
        fill="#4388FF"
      />
    </g>
    <defs>
      <clipPath id="aUnionIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const ServiceAdminIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M9.502 2.329c.67-.244 1.41.101 1.655.771l.326.896a8.14 8.14 0 0 1 1.727.075l.403-.864a1.291 1.291 0 0 1 1.716-.624l1.742.812c.646.302.926 1.07.624 1.716l-.403.864a8.06 8.06 0 0 1 1.169 1.275l.896-.326a1.291 1.291 0 0 1 1.654.772l.658 1.806c.244.67-.102 1.41-.772 1.655l-.896.326a8.164 8.164 0 0 1-.075 1.728l.864.402c.646.302.926 1.07.625 1.716l-.813 1.742a1.291 1.291 0 0 1-1.716.625l-.864-.404a8.062 8.062 0 0 1-1.275 1.169l.326.896a1.291 1.291 0 0 1-.771 1.655l-1.806.657a1.291 1.291 0 0 1-1.655-.772l-.326-.896a8.167 8.167 0 0 1-1.728-.075l-.403.864a1.291 1.291 0 0 1-1.716.625l-1.742-.813a1.291 1.291 0 0 1-.624-1.716l.403-.864a8.06 8.06 0 0 1-1.168-1.274l-.896.326a1.291 1.291 0 0 1-1.655-.772l-.658-1.806A1.291 1.291 0 0 1 3.1 12.84l.896-.326a8.132 8.132 0 0 1 .075-1.728l-.864-.403a1.291 1.291 0 0 1-.624-1.715l.812-1.743a1.291 1.291 0 0 1 1.716-.624l.864.403A8.064 8.064 0 0 1 7.25 5.537l-.326-.896c-.244-.67.101-1.411.771-1.655l1.807-.657ZM8.56 4.396l.665 1.829-.251.135a6.43 6.43 0 0 0-2.329 2.134l-.156.239-1.764-.822-.533 1.144 1.762.822-.082.273a6.427 6.427 0 0 0-.137 3.156l.058.28-1.828.665.431 1.186 1.828-.665.136.251a6.43 6.43 0 0 0 2.134 2.33l.239.156-.822 1.763 1.144.534.822-1.763.273.082a6.425 6.425 0 0 0 3.156.137l.28-.057.665 1.828 1.186-.432-.665-1.828.251-.135a6.43 6.43 0 0 0 2.33-2.135l.156-.239 1.763.823.534-1.144-1.763-.822.082-.274a6.425 6.425 0 0 0 .137-3.156l-.057-.28 1.828-.665L19.6 8.56l-1.828.665-.135-.251a6.43 6.43 0 0 0-2.135-2.329l-.239-.156.823-1.764-1.144-.533-.822 1.762-.274-.082a6.427 6.427 0 0 0-3.156-.137l-.28.058-.665-1.828-1.186.431ZM9.266 12a2.733 2.733 0 1 1 5.465 0 2.733 2.733 0 0 1-5.465 0Zm2.733-1.112a1.112 1.112 0 1 0 0 2.223 1.112 1.112 0 0 0 0-2.223Z"
      clipRule="evenodd"
    />
  </svg>
)
export const ServiceAdminIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M9.502 2.329c.67-.244 1.41.101 1.655.771l.326.896a8.14 8.14 0 0 1 1.727.075l.403-.864a1.291 1.291 0 0 1 1.716-.624l1.742.812c.646.302.926 1.07.624 1.716l-.403.864a8.06 8.06 0 0 1 1.169 1.275l.896-.326a1.291 1.291 0 0 1 1.654.772l.658 1.806c.244.67-.102 1.41-.772 1.655l-.896.326a8.164 8.164 0 0 1-.075 1.728l.864.402c.646.302.926 1.07.625 1.716l-.813 1.742a1.291 1.291 0 0 1-1.716.625l-.864-.404a8.062 8.062 0 0 1-1.275 1.169l.326.896a1.291 1.291 0 0 1-.771 1.655l-1.806.657a1.291 1.291 0 0 1-1.655-.772l-.326-.896a8.167 8.167 0 0 1-1.728-.075l-.403.864a1.291 1.291 0 0 1-1.716.625l-1.742-.813a1.291 1.291 0 0 1-.624-1.716l.403-.864a8.06 8.06 0 0 1-1.168-1.274l-.896.326a1.291 1.291 0 0 1-1.655-.772l-.658-1.806A1.291 1.291 0 0 1 3.1 12.84l.896-.326a8.132 8.132 0 0 1 .075-1.728l-.864-.403a1.291 1.291 0 0 1-.624-1.715l.812-1.743a1.291 1.291 0 0 1 1.716-.624l.864.403A8.064 8.064 0 0 1 7.25 5.537l-.326-.896c-.244-.67.101-1.411.771-1.655l1.807-.657ZM8.56 4.396l.665 1.829-.251.135a6.43 6.43 0 0 0-2.329 2.134l-.156.239-1.764-.822-.533 1.144 1.762.822-.082.273a6.427 6.427 0 0 0-.137 3.156l.058.28-1.828.665.431 1.186 1.828-.665.136.251a6.43 6.43 0 0 0 2.134 2.33l.239.156-.822 1.763 1.144.534.822-1.763.273.082a6.425 6.425 0 0 0 3.156.137l.28-.057.665 1.828 1.186-.432-.665-1.828.251-.135a6.43 6.43 0 0 0 2.33-2.135l.156-.239 1.763.823.534-1.144-1.763-.822.082-.274a6.425 6.425 0 0 0 .137-3.156l-.057-.28 1.828-.665L19.6 8.56l-1.828.665-.135-.251a6.43 6.43 0 0 0-2.135-2.329l-.239-.156.823-1.764-1.144-.533-.822 1.762-.274-.082a6.427 6.427 0 0 0-3.156-.137l-.28.058-.665-1.828-1.186.431ZM9.266 12a2.733 2.733 0 1 1 5.465 0 2.733 2.733 0 0 1-5.465 0Zm2.733-1.112a1.112 1.112 0 1 0 0 2.223 1.112 1.112 0 0 0 0-2.223Z"
      clipRule="evenodd"
    />
  </svg>
)

export const ServiceAdminIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M9.502 2.329c.67-.244 1.41.101 1.655.771l.326.896a8.14 8.14 0 0 1 1.727.075l.403-.864a1.291 1.291 0 0 1 1.716-.624l1.742.812c.646.302.926 1.07.624 1.716l-.403.864a8.06 8.06 0 0 1 1.169 1.275l.896-.326a1.291 1.291 0 0 1 1.654.772l.658 1.806c.244.67-.102 1.41-.772 1.655l-.896.326a8.164 8.164 0 0 1-.075 1.728l.864.402c.646.302.926 1.07.625 1.716l-.813 1.742a1.291 1.291 0 0 1-1.716.625l-.864-.404a8.062 8.062 0 0 1-1.275 1.169l.326.896a1.291 1.291 0 0 1-.771 1.655l-1.806.657a1.291 1.291 0 0 1-1.655-.772l-.326-.896a8.167 8.167 0 0 1-1.728-.075l-.403.864a1.291 1.291 0 0 1-1.716.625l-1.742-.813a1.291 1.291 0 0 1-.624-1.716l.403-.864a8.06 8.06 0 0 1-1.168-1.274l-.896.326a1.291 1.291 0 0 1-1.655-.772l-.658-1.806A1.291 1.291 0 0 1 3.1 12.84l.896-.326a8.132 8.132 0 0 1 .075-1.728l-.864-.403a1.291 1.291 0 0 1-.624-1.715l.812-1.743a1.291 1.291 0 0 1 1.716-.624l.864.403A8.064 8.064 0 0 1 7.25 5.537l-.326-.896c-.244-.67.101-1.411.771-1.655l1.807-.657ZM8.56 4.396l.665 1.829-.251.135a6.43 6.43 0 0 0-2.329 2.134l-.156.239-1.764-.822-.533 1.144 1.762.822-.082.273a6.427 6.427 0 0 0-.137 3.156l.058.28-1.828.665.431 1.186 1.828-.665.136.251a6.43 6.43 0 0 0 2.134 2.33l.239.156-.822 1.763 1.144.534.822-1.763.273.082a6.425 6.425 0 0 0 3.156.137l.28-.057.665 1.828 1.186-.432-.665-1.828.251-.135a6.43 6.43 0 0 0 2.33-2.135l.156-.239 1.763.823.534-1.144-1.763-.822.082-.274a6.425 6.425 0 0 0 .137-3.156l-.057-.28 1.828-.665L19.6 8.56l-1.828.665-.135-.251a6.43 6.43 0 0 0-2.135-2.329l-.239-.156.823-1.764-1.144-.533-.822 1.762-.274-.082a6.427 6.427 0 0 0-3.156-.137l-.28.058-.665-1.828-1.186.431ZM9.266 12a2.733 2.733 0 1 1 5.465 0 2.733 2.733 0 0 1-5.465 0Zm2.733-1.112a1.112 1.112 0 1 0 0 2.223 1.112 1.112 0 0 0 0-2.223Z"
      clipRule="evenodd"
    />
  </svg>
)

export const ServiceAdvanceIcon = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20V16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16V17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H13V20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H8C8.28333 17 8.52083 17.0958 8.7125 17.2875C8.90417 17.4792 9 17.7167 9 18C9 18.2833 8.90417 18.5208 8.7125 18.7125C8.52083 18.9042 8.28333 19 8 19H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14V13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H7V10C7 9.71667 7.09583 9.47917 7.2875 9.2875C7.47917 9.09583 7.71667 9 8 9C8.28333 9 8.52083 9.09583 8.7125 9.2875C8.90417 9.47917 9 9.71667 9 10V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H12ZM16 9C15.7167 9 15.4792 8.90417 15.2875 8.7125C15.0958 8.52083 15 8.28333 15 8V4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4V5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H17V8C17 8.28333 16.9042 8.52083 16.7125 8.7125C16.5208 8.90417 16.2833 9 16 9ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H12C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7H4Z"
      fill="#fff"
    />
  </svg>
)

export const ServiceAdvanceIconBlue = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20V16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16V17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H13V20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H8C8.28333 17 8.52083 17.0958 8.7125 17.2875C8.90417 17.4792 9 17.7167 9 18C9 18.2833 8.90417 18.5208 8.7125 18.7125C8.52083 18.9042 8.28333 19 8 19H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14V13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H7V10C7 9.71667 7.09583 9.47917 7.2875 9.2875C7.47917 9.09583 7.71667 9 8 9C8.28333 9 8.52083 9.09583 8.7125 9.2875C8.90417 9.47917 9 9.71667 9 10V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H12ZM16 9C15.7167 9 15.4792 8.90417 15.2875 8.7125C15.0958 8.52083 15 8.28333 15 8V4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4V5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H17V8C17 8.28333 16.9042 8.52083 16.7125 8.7125C16.5208 8.90417 16.2833 9 16 9ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H12C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7H4Z"
      fill="#4388FF"
    />
  </svg>
)

export const ServiceAdvanceIconGrey = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 21C11.7167 21 11.4792 20.9042 11.2875 20.7125C11.0958 20.5208 11 20.2833 11 20V16C11 15.7167 11.0958 15.4792 11.2875 15.2875C11.4792 15.0958 11.7167 15 12 15C12.2833 15 12.5208 15.0958 12.7125 15.2875C12.9042 15.4792 13 15.7167 13 16V17H20C20.2833 17 20.5208 17.0958 20.7125 17.2875C20.9042 17.4792 21 17.7167 21 18C21 18.2833 20.9042 18.5208 20.7125 18.7125C20.5208 18.9042 20.2833 19 20 19H13V20C13 20.2833 12.9042 20.5208 12.7125 20.7125C12.5208 20.9042 12.2833 21 12 21ZM4 19C3.71667 19 3.47917 18.9042 3.2875 18.7125C3.09583 18.5208 3 18.2833 3 18C3 17.7167 3.09583 17.4792 3.2875 17.2875C3.47917 17.0958 3.71667 17 4 17H8C8.28333 17 8.52083 17.0958 8.7125 17.2875C8.90417 17.4792 9 17.7167 9 18C9 18.2833 8.90417 18.5208 8.7125 18.7125C8.52083 18.9042 8.28333 19 8 19H4ZM8 15C7.71667 15 7.47917 14.9042 7.2875 14.7125C7.09583 14.5208 7 14.2833 7 14V13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H7V10C7 9.71667 7.09583 9.47917 7.2875 9.2875C7.47917 9.09583 7.71667 9 8 9C8.28333 9 8.52083 9.09583 8.7125 9.2875C8.90417 9.47917 9 9.71667 9 10V14C9 14.2833 8.90417 14.5208 8.7125 14.7125C8.52083 14.9042 8.28333 15 8 15ZM12 13C11.7167 13 11.4792 12.9042 11.2875 12.7125C11.0958 12.5208 11 12.2833 11 12C11 11.7167 11.0958 11.4792 11.2875 11.2875C11.4792 11.0958 11.7167 11 12 11H20C20.2833 11 20.5208 11.0958 20.7125 11.2875C20.9042 11.4792 21 11.7167 21 12C21 12.2833 20.9042 12.5208 20.7125 12.7125C20.5208 12.9042 20.2833 13 20 13H12ZM16 9C15.7167 9 15.4792 8.90417 15.2875 8.7125C15.0958 8.52083 15 8.28333 15 8V4C15 3.71667 15.0958 3.47917 15.2875 3.2875C15.4792 3.09583 15.7167 3 16 3C16.2833 3 16.5208 3.09583 16.7125 3.2875C16.9042 3.47917 17 3.71667 17 4V5H20C20.2833 5 20.5208 5.09583 20.7125 5.2875C20.9042 5.47917 21 5.71667 21 6C21 6.28333 20.9042 6.52083 20.7125 6.7125C20.5208 6.90417 20.2833 7 20 7H17V8C17 8.28333 16.9042 8.52083 16.7125 8.7125C16.5208 8.90417 16.2833 9 16 9ZM4 7C3.71667 7 3.47917 6.90417 3.2875 6.7125C3.09583 6.52083 3 6.28333 3 6C3 5.71667 3.09583 5.47917 3.2875 5.2875C3.47917 5.09583 3.71667 5 4 5H12C12.2833 5 12.5208 5.09583 12.7125 5.2875C12.9042 5.47917 13 5.71667 13 6C13 6.28333 12.9042 6.52083 12.7125 6.7125C12.5208 6.90417 12.2833 7 12 7H4Z"
      fill="#717275"
    />
  </svg>
)

export const MarketplaceIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M19.47 13.34a6.305 6.305 0 0 1-1.3.14 5.79 5.79 0 0 1-3.09-.86 5.95 5.95 0 0 1-6.16 0c-.928.572-2 .87-3.09.86a6.306 6.306 0 0 1-1.3-.14 5.39 5.39 0 0 1-1.3-.44L3 12.79v6.183C3 20.5 3 20.81 5.8 20.81h3.39v-4.9a.75.75 0 0 1 .75-.75h4.12a.75.75 0 0 1 .75.75v4.86h3.36C21 20.77 21 20.5 21 18v-5.21l-.2.11a5.39 5.39 0 0 1-1.33.44ZM5.52 3.23h2.87v7.93a4.25 4.25 0 0 1-2.56.84 4.354 4.354 0 0 1-1.3-.19 3.513 3.513 0 0 1-.64-.24 2.85 2.85 0 0 1-.89-.65 3.33 3.33 0 0 1-.85-3l.58-2.73a2.72 2.72 0 0 1 2.79-1.96ZM9.39 3.23h5.22v7.88a4.35 4.35 0 0 1-5.22 0V3.23ZM21 10.91a2.878 2.878 0 0 1-.86.64c-.205.1-.42.18-.64.24a4.35 4.35 0 0 1-1.3.19 4.25 4.25 0 0 1-2.56-.82V3.23h2.87a2.72 2.72 0 0 1 2.76 1.94l.58 2.7a.405.405 0 0 1 0 .11 3.28 3.28 0 0 1-.85 2.93Z"
      fill="#fff"
    />
  </svg>
)
export const MarketplaceIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M19.47 13.34a6.305 6.305 0 0 1-1.3.14 5.79 5.79 0 0 1-3.09-.86 5.95 5.95 0 0 1-6.16 0c-.928.572-2 .87-3.09.86a6.306 6.306 0 0 1-1.3-.14 5.39 5.39 0 0 1-1.3-.44L3 12.79v6.183C3 20.5 3 20.81 5.8 20.81h3.39v-4.9a.75.75 0 0 1 .75-.75h4.12a.75.75 0 0 1 .75.75v4.86h3.36C21 20.77 21 20.5 21 18v-5.21l-.2.11a5.39 5.39 0 0 1-1.33.44ZM5.52 3.23h2.87v7.93a4.25 4.25 0 0 1-2.56.84 4.354 4.354 0 0 1-1.3-.19 3.513 3.513 0 0 1-.64-.24 2.85 2.85 0 0 1-.89-.65 3.33 3.33 0 0 1-.85-3l.58-2.73a2.72 2.72 0 0 1 2.79-1.96ZM9.39 3.23h5.22v7.88a4.35 4.35 0 0 1-5.22 0V3.23ZM21 10.91a2.878 2.878 0 0 1-.86.64c-.205.1-.42.18-.64.24a4.35 4.35 0 0 1-1.3.19 4.25 4.25 0 0 1-2.56-.82V3.23h2.87a2.72 2.72 0 0 1 2.76 1.94l.58 2.7a.405.405 0 0 1 0 .11 3.28 3.28 0 0 1-.85 2.93Z"
      fill="#4388FF"
    />
  </svg>
)

export const MarketplaceIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M19.47 13.34a6.305 6.305 0 0 1-1.3.14 5.79 5.79 0 0 1-3.09-.86 5.95 5.95 0 0 1-6.16 0c-.928.572-2 .87-3.09.86a6.306 6.306 0 0 1-1.3-.14 5.39 5.39 0 0 1-1.3-.44L3 12.79v6.183C3 20.5 3 20.81 5.8 20.81h3.39v-4.9a.75.75 0 0 1 .75-.75h4.12a.75.75 0 0 1 .75.75v4.86h3.36C21 20.77 21 20.5 21 18v-5.21l-.2.11a5.39 5.39 0 0 1-1.33.44ZM5.52 3.23h2.87v7.93a4.25 4.25 0 0 1-2.56.84 4.354 4.354 0 0 1-1.3-.19 3.513 3.513 0 0 1-.64-.24 2.85 2.85 0 0 1-.89-.65 3.33 3.33 0 0 1-.85-3l.58-2.73a2.72 2.72 0 0 1 2.79-1.96ZM9.39 3.23h5.22v7.88a4.35 4.35 0 0 1-5.22 0V3.23ZM21 10.91a2.878 2.878 0 0 1-.86.64c-.205.1-.42.18-.64.24a4.35 4.35 0 0 1-1.3.19 4.25 4.25 0 0 1-2.56-.82V3.23h2.87a2.72 2.72 0 0 1 2.76 1.94l.58 2.7a.405.405 0 0 1 0 .11 3.28 3.28 0 0 1-.85 2.93Z"
      fill="#717275"
    />
  </svg>
)

export const ExpandLessIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M19.851 14.808a.5.5 0 0 0 0-.707l-7.497-7.498a.5.5 0 0 0-.708 0L4.15 14.101a.5.5 0 0 0 0 .707l1.074 1.074a.5.5 0 0 0 .707 0l5.716-5.711a.5.5 0 0 1 .707 0l5.715 5.713a.5.5 0 0 0 .707 0l1.076-1.076Z"
      fill="#717275"
    />
  </svg>
)
export const ExpandMoreIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M4.149 9.192a.5.5 0 0 0 0 .707l7.497 7.498a.5.5 0 0 0 .708 0l7.497-7.498a.5.5 0 0 0 0-.707l-1.074-1.074a.5.5 0 0 0-.707 0l-5.716 5.711a.5.5 0 0 1-.707 0L5.932 8.116a.5.5 0 0 0-.707 0L4.149 9.192Z"
      fill="#717275"
    />
  </svg>
)
export const ExpandLessBlueIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M19.851 14.808a.5.5 0 0 0 0-.707l-7.497-7.498a.5.5 0 0 0-.708 0L4.15 14.101a.5.5 0 0 0 0 .707l1.074 1.074a.5.5 0 0 0 .707 0l5.716-5.711a.5.5 0 0 1 .707 0l5.715 5.713a.5.5 0 0 0 .707 0l1.076-1.076Z"
      fill="#4388FF"
    />
  </svg>
)
export const ExpandMoreBlueIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M4.149 9.192a.5.5 0 0 0 0 .707l7.497 7.498a.5.5 0 0 0 .708 0l7.497-7.498a.5.5 0 0 0 0-.707l-1.074-1.074a.5.5 0 0 0-.707 0l-5.716 5.711a.5.5 0 0 1-.707 0L5.932 8.116a.5.5 0 0 0-.707 0L4.149 9.192Z"
      fill="#4388FF"
    />
  </svg>
)
export const BackArrowIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aBackArrowIcon)">
      <path
        d="M20 11.5a.5.5 0 0 0-.5-.5H8.434a.25.25 0 0 1-.177-.427l4.808-4.808a.5.5 0 0 0-.001-.709l-.71-.705a.5.5 0 0 0-.706.001l-6.94 6.94a1 1 0 0 0 0 1.415l6.938 6.94a.5.5 0 0 0 .708 0l.703-.704a.5.5 0 0 0 0-.707l-4.801-4.81A.25.25 0 0 1 8.433 13H19.5a.5.5 0 0 0 .5-.5v-1Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="aBackArrowIcon">
        <path fill="#fff" transform="rotate(-90 12 12)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const RightArrowIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <g clipPath="url(#aRightArrowIcon)">
      <path
        d="m19.288 13.411 5.236 5.235.853.854H12.5v1h12.876l-.852.853-5.227 5.237.703.703L27.293 20l-7.294-7.294-.71.705Z"
        fill="#fff"
        stroke="#fff"
      />
    </g>
    <defs>
      <clipPath id="aRightArrowIcon">
        <path fill="#fff" transform="matrix(-1 0 0 1 40 0)" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const CopyIcon = (props: any) => (
  <svg width={20} height={20} fill="none" {...props}>
    <g clipPath="url(#aCopyIcon)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.164 1.666a.833.833 0 0 0-.833.833v13.35c0 .461.373.834.833.834H5.92a.208.208 0 0 0 .209-.208v-.978a.208.208 0 0 0-.209-.208h-.985a.208.208 0 0 1-.209-.209V3.478c0-.23.187-.416.417-.416h8.245c.115 0 .208.093.208.208v.98c0 .116.093.21.208.21h.98a.208.208 0 0 0 .208-.21V2.5a.833.833 0 0 0-.833-.834H4.164ZM8.36 5.858a.833.833 0 0 0-.833.834V17.5c0 .46.373.833.833.833h7.47c.461 0 .834-.373.834-.833V6.692a.833.833 0 0 0-.833-.834H8.36Zm.566 1.81c0-.23.186-.416.416-.416h5.506c.23 0 .416.187.416.417v8.847c0 .23-.186.416-.416.416H9.342a.417.417 0 0 1-.416-.416V7.669Z"
        fill="#4388FF"
      />
    </g>
    <defs>
      <clipPath id="aCopyIcon">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const UsageIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.799 3.75a8.38 8.38 0 1 0 7.864 13.384l-7.86-4.333H10.8V3.75Zm9.032 11.284a8.364 8.364 0 0 0-.572-7.178 8.366 8.366 0 0 0-6.057-4.104v7.627l6.63 3.655Z"
      fill="#5F5757"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.799 3.75A8.319 8.319 0 0 0 7.81 4.79a8.38 8.38 0 1 0 10.854 12.345l-7.86-4.333h-.005V3.75Zm2.403 7.629V3.752a8.354 8.354 0 0 1 6.057 4.104 8.353 8.353 0 0 1 .572 7.178l-6.63-3.655Z"
      fill="#fff"
    />
  </svg>
)

export const UsageIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M10.79 2.042C5.836 2.639 2 6.856 2 11.969c0 5.523 4.477 10 10 10a9.984 9.984 0 0 0 7.961-3.948l-1.469-.848A8.32 8.32 0 1 1 10.79 3.737V2.042Zm2.331 1.682a8.322 8.322 0 0 1 6.694 11.107l1.473.85c.46-1.147.712-2.4.712-3.712 0-5.144-3.884-9.38-8.879-9.938v1.693Z"
      clipRule="evenodd"
    />
  </svg>
)

export const UsageIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M10.79 2.042C5.836 2.639 2 6.856 2 11.969c0 5.523 4.477 10 10 10a9.984 9.984 0 0 0 7.961-3.948l-1.469-.848A8.32 8.32 0 1 1 10.79 3.737V2.042Zm2.331 1.682a8.322 8.322 0 0 1 6.694 11.107l1.473.85c.46-1.147.712-2.4.712-3.712 0-5.144-3.884-9.38-8.879-9.938v1.693Z"
      clipRule="evenodd"
    />
  </svg>
)

export const WebhookIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#ahook)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m13.198 3.328.008.004a4.338 4.338 0 0 1 2.09 1.345 4.355 4.355 0 0 1 1.03 3.176 4.37 4.37 0 0 1-.108.667l-1.632-.394a2.66 2.66 0 1 0-4.637 1.07c.36.434.856.753 1.425.89l-3.075 4.917a2.34 2.34 0 1 1-1.469-.82l2.2-3.518a4.34 4.34 0 0 1 4.168-7.337ZM7.92 14.64Zm13.895 2.33a4.34 4.34 0 0 0-5.756-4.563l-2.188-3.5a2.34 2.34 0 0 1-1.424.891l3.078 4.921a2.658 2.658 0 0 1 1.463-.829 2.66 2.66 0 1 1-1.361 4.498l-1.185 1.192a4.342 4.342 0 0 0 4.556.995 4.355 4.355 0 0 0 2.434-2.234 4.36 4.36 0 0 0 .383-1.372ZM9.16 16.5a2.673 2.673 0 0 1-.136.84 2.661 2.661 0 1 1-3.514-3.309l-.625-1.56a4.36 4.36 0 0 0-2.102 1.788 4.364 4.364 0 0 0-.623 2.242 4.364 4.364 0 0 0 .164 1.183 4.311 4.311 0 0 0 1.52 2.249 4.357 4.357 0 0 0 2.223.886l.048.005a4.388 4.388 0 0 0 1.558-.145 4.345 4.345 0 0 0 3.086-3.338h4.556a2.34 2.34 0 1 0 0-1.68h-6.29a2.682 2.682 0 0 1 .136.84Zm-.421-.84h-.054l.007.018.047-.017ZM14.34 7.5a2.34 2.34 0 1 1-4.68 0 2.34 2.34 0 0 1 4.68 0Z"
        fill="#717275"
      />
    </g>
    <defs>
      <clipPath id="ahook">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const WebhookIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="m14.628 8.055 1.66.401a4.468 4.468 0 0 0 .123-1.037 4.44 4.44 0 0 0-.95-2.74 4.43 4.43 0 0 0-2.254-1.511 4.406 4.406 0 0 0-3.854.716 4.435 4.435 0 0 0-1.51 2.057c-.164.462-.254.96-.254 1.478a4.406 4.406 0 0 0 1.393 3.221l-2.236 3.582a2.383 2.383 0 1 0 .332 4.646 2.383 2.383 0 0 0 1.16-3.811l3.126-5.006a2.7 2.7 0 0 1-1.448-.908 2.7 2.7 0 0 1-.62-1.724A2.706 2.706 0 0 1 12 4.71a2.706 2.706 0 0 1 2.628 3.345Zm6.91 6.554a4.434 4.434 0 0 0-1.924-1.954 4.422 4.422 0 0 0-3.489-.243L13.901 8.85a2.395 2.395 0 0 1-1.447.908l3.128 5.01a2.69 2.69 0 0 1 2.007-.895 2.706 2.706 0 0 1 2.704 2.708 2.706 2.706 0 0 1-2.704 2.709c-.743 0-1.416-.3-1.904-.787l-1.203 1.214A4.41 4.41 0 0 0 17.589 21a4.404 4.404 0 0 0 3.947-2.445 4.442 4.442 0 0 0 .001-3.946ZM9.113 16.581a2.722 2.722 0 0 1-.138.856A2.704 2.704 0 0 1 6.41 19.29a2.706 2.706 0 0 1-2.704-2.709c0-1.139.703-2.114 1.697-2.514L4.77 12.48a4.434 4.434 0 0 0-2.68 3.219 4.447 4.447 0 0 0 .392 2.891 4.436 4.436 0 0 0 1.834 1.88 4.387 4.387 0 0 0 1.679.51l.014.002a4.455 4.455 0 0 0 1.574-.141 4.42 4.42 0 0 0 3.157-3.404h4.63a2.38 2.38 0 0 0 4.599-.856 2.379 2.379 0 0 0-4.598-.855H8.975a2.716 2.716 0 0 1 .138.855Zm9.146 0a.671.671 0 1 1-1.342.002.671.671 0 0 1 1.342-.002ZM6.6 17.226a.672.672 0 0 0-.377-1.29.672.672 0 0 0 .377 1.29Zm2.087-1.5H8.63l.007.018.048-.018ZM12 8.09a.671.671 0 1 0-.001-1.342A.671.671 0 0 0 12 8.09Zm2.378-.671a2.378 2.378 0 1 1-4.756 0A2.38 2.38 0 0 1 12 5.036a2.38 2.38 0 0 1 2.378 2.383Z"
      clipRule="evenodd"
    />
  </svg>
)
export const WebhookIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#717275"
      fillRule="evenodd"
      d="m14.628 8.055 1.66.401a4.468 4.468 0 0 0 .123-1.037 4.44 4.44 0 0 0-.95-2.74 4.43 4.43 0 0 0-2.254-1.511 4.406 4.406 0 0 0-3.854.716 4.435 4.435 0 0 0-1.51 2.057c-.164.462-.254.96-.254 1.478a4.406 4.406 0 0 0 1.393 3.221l-2.236 3.582a2.383 2.383 0 1 0 .332 4.646 2.383 2.383 0 0 0 1.16-3.811l3.126-5.006a2.7 2.7 0 0 1-1.448-.908 2.7 2.7 0 0 1-.62-1.724A2.706 2.706 0 0 1 12 4.71a2.706 2.706 0 0 1 2.628 3.345Zm6.91 6.554a4.434 4.434 0 0 0-1.924-1.954 4.422 4.422 0 0 0-3.489-.243L13.901 8.85a2.395 2.395 0 0 1-1.447.908l3.128 5.01a2.69 2.69 0 0 1 2.007-.895 2.706 2.706 0 0 1 2.704 2.708 2.706 2.706 0 0 1-2.704 2.709c-.743 0-1.416-.3-1.904-.787l-1.203 1.214A4.41 4.41 0 0 0 17.589 21a4.404 4.404 0 0 0 3.947-2.445 4.442 4.442 0 0 0 .001-3.946ZM9.113 16.581a2.722 2.722 0 0 1-.138.856A2.704 2.704 0 0 1 6.41 19.29a2.706 2.706 0 0 1-2.704-2.709c0-1.139.703-2.114 1.697-2.514L4.77 12.48a4.434 4.434 0 0 0-2.68 3.219 4.447 4.447 0 0 0 .392 2.891 4.436 4.436 0 0 0 1.834 1.88 4.387 4.387 0 0 0 1.679.51l.014.002a4.455 4.455 0 0 0 1.574-.141 4.42 4.42 0 0 0 3.157-3.404h4.63a2.38 2.38 0 0 0 4.599-.856 2.379 2.379 0 0 0-4.598-.855H8.975a2.716 2.716 0 0 1 .138.855Zm9.146 0a.671.671 0 1 1-1.342.002.671.671 0 0 1 1.342-.002ZM6.6 17.226a.672.672 0 0 0-.377-1.29.672.672 0 0 0 .377 1.29Zm2.087-1.5H8.63l.007.018.048-.018ZM12 8.09a.671.671 0 1 0-.001-1.342A.671.671 0 0 0 12 8.09Zm2.378-.671a2.378 2.378 0 1 1-4.756 0A2.38 2.38 0 0 1 12 5.036a2.38 2.38 0 0 1 2.378 2.383Z"
      clipRule="evenodd"
    />
  </svg>
)
export const WebhookLogIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.016 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14ZM6.556 5.355a.843.843 0 1 0 0 1.686h9.218a.843.843 0 1 0 0-1.686H6.555Zm.007 3.378a.838.838 0 1 0 0 1.676h10.925a.838.838 0 0 0 0-1.676H6.563Zm8.527 5.006a.828.828 0 0 0-.828-.828H6.553a.828.828 0 1 0 0 1.656h7.709c.457 0 .828-.37.828-.828Zm3.236 3.348a.837.837 0 0 0-.836-.836H6.535a.837.837 0 0 0 0 1.673H17.49a.837.837 0 0 0 .836-.837Z"
      fill="#fff"
    />
  </svg>
)

export const WebhookLogIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.016 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14ZM6.556 5.355a.843.843 0 1 0 0 1.686h9.218a.843.843 0 1 0 0-1.686H6.555Zm.007 3.378a.838.838 0 1 0 0 1.676h10.925a.838.838 0 0 0 0-1.676H6.563Zm8.527 5.006a.828.828 0 0 0-.828-.828H6.553a.828.828 0 1 0 0 1.656h7.709c.457 0 .828-.37.828-.828Zm3.236 3.348a.837.837 0 0 0-.836-.836H6.535a.837.837 0 0 0 0 1.673H17.49a.837.837 0 0 0 .836-.837Z"
      fill="#717275"
    />
  </svg>
)
export const WebhookLogIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.016 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14ZM6.556 5.355a.843.843 0 1 0 0 1.686h9.218a.843.843 0 1 0 0-1.686H6.555Zm.007 3.378a.838.838 0 1 0 0 1.676h10.925a.838.838 0 0 0 0-1.676H6.563Zm8.527 5.006a.828.828 0 0 0-.828-.828H6.553a.828.828 0 1 0 0 1.656h7.709c.457 0 .828-.37.828-.828Zm3.236 3.348a.837.837 0 0 0-.836-.836H6.535a.837.837 0 0 0 0 1.673H17.49a.837.837 0 0 0 .836-.837Z"
      fill="#4388FF"
    />
  </svg>
)
export const APIKeyIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aAPIKeyIcon)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.84 12a9.81 9.81 0 0 1-2.882 6.958L17.77 17.77a8.161 8.161 0 0 0-4.93-13.887v.884A3.341 3.341 0 0 1 15.34 8v1a1.34 1.34 0 0 1-1 1.296v1.544h-1.68v-1.5h-1.32v1.5H9.66v-1.543A1.34 1.34 0 0 1 8.66 9V8a3.341 3.341 0 0 1 2.5-3.233V3.036c0-.475.365-.876.84-.876 5.435 0 9.84 4.406 9.84 9.84Zm-18 0c0-2.253.913-4.293 2.39-5.77L5.042 5.042A9.81 9.81 0 0 0 2.16 12c0 5.434 4.406 9.84 9.84 9.84.476 0 .84-.4.84-.877v-2.73A3.342 3.342 0 0 0 15.34 15v-1c0-.74-.6-1.34-1.34-1.34h-4c-.74 0-1.34.6-1.34 1.34v1a3.341 3.341 0 0 0 2.5 3.233v1.884A8.161 8.161 0 0 1 3.84 12Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="aAPIKeyIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const APIKeyIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M18.364 18.364A9 9 0 0 0 12 3c-.435 0-.768.367-.768.802v1.582a3.056 3.056 0 0 0-2.287 2.957v.915c0 .57.388 1.048.915 1.186v1.412h1.536v-1.372h1.208v1.372h1.536v-1.412c.526-.138.915-.616.915-1.186v-.915a3.056 3.056 0 0 0-2.287-2.957v-.808a7.464 7.464 0 0 1 4.51 12.701l1.086 1.087ZM12 6.824c-.839 0-1.518.679-1.518 1.517v.604h3.036v-.604c0-.838-.68-1.518-1.518-1.518ZM4.537 12a7.44 7.44 0 0 1 2.186-5.277L5.636 5.636A9 9 0 0 0 12 21c.435 0 .768-.367.768-.802v-2.497a3.056 3.056 0 0 0 2.287-2.957v-.915c0-.677-.549-1.226-1.226-1.226h-3.658c-.677 0-1.226.55-1.226 1.226v.915c0 1.422.972 2.616 2.287 2.957v1.723A7.464 7.464 0 0 1 4.537 12Zm5.945 2.744v-.604h3.037v.604a1.518 1.518 0 0 1-3.037 0Z"
      clipRule="evenodd"
    />
  </svg>
)
export const APIKeyIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M18.364 18.364A9 9 0 0 0 12 3c-.435 0-.768.367-.768.802v1.582a3.056 3.056 0 0 0-2.287 2.957v.915c0 .57.388 1.048.915 1.186v1.412h1.536v-1.372h1.208v1.372h1.536v-1.412c.526-.138.915-.616.915-1.186v-.915a3.056 3.056 0 0 0-2.287-2.957v-.808a7.464 7.464 0 0 1 4.51 12.701l1.086 1.087ZM12 6.824c-.839 0-1.518.679-1.518 1.517v.604h3.036v-.604c0-.838-.68-1.518-1.518-1.518ZM4.537 12a7.44 7.44 0 0 1 2.186-5.277L5.636 5.636A9 9 0 0 0 12 21c.435 0 .768-.367.768-.802v-2.497a3.056 3.056 0 0 0 2.287-2.957v-.915c0-.677-.549-1.226-1.226-1.226h-3.658c-.677 0-1.226.55-1.226 1.226v.915c0 1.422.972 2.616 2.287 2.957v1.723A7.464 7.464 0 0 1 4.537 12Zm5.945 2.744v-.604h3.037v.604a1.518 1.518 0 0 1-3.037 0Z"
      clipRule="evenodd"
    />
  </svg>
)

export const TeamIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aTeamIcon)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-9 0a3 3 0 0 0-1.847-2.77A2 2 0 0 1 10 8h4a2 2 0 0 1 1.846 1.23A3 3 0 0 0 14.763 14H9.236c.475-.53.764-1.232.764-2Zm-7 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4H3v-4Zm12-2a2 2 0 0 0-2 2v4h8v-4a2 2 0 0 0-2-2h-4Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const TeamIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aTeamIconBlue)">
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4.8 17c0-.11.09-.2.2-.2h4c.11 0 .2.09.2.2v2.2H4.8V17ZM3 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4H3v-4Zm12-.2a.2.2 0 0 0-.2.2v2.2h4.4V17a.2.2 0 0 0-.2-.2h-4Zm0-1.8a2 2 0 0 0-2 2v4h8v-4a2 2 0 0 0-2-2h-4Zm-1-5.2h-4a.2.2 0 0 0-.2.2v.921A3.01 3.01 0 0 0 8.154 9.23 2 2 0 0 1 10 8h4a2 2 0 0 1 1.846 1.23 3.01 3.01 0 0 0-1.646 1.69V10a.2.2 0 0 0-.2-.2ZM9.236 14c.433-.484.712-1.11.757-1.8h4.013c.046.69.324 1.316.758 1.8H9.236Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const TeamIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aTeamIconGrey)">
      <path
        fill="#717275"
        fillRule="evenodd"
        d="M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4.8 17c0-.11.09-.2.2-.2h4c.11 0 .2.09.2.2v2.2H4.8V17ZM3 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4H3v-4Zm12-.2a.2.2 0 0 0-.2.2v2.2h4.4V17a.2.2 0 0 0-.2-.2h-4Zm0-1.8a2 2 0 0 0-2 2v4h8v-4a2 2 0 0 0-2-2h-4Zm-1-5.2h-4a.2.2 0 0 0-.2.2v.921A3.01 3.01 0 0 0 8.154 9.23 2 2 0 0 1 10 8h4a2 2 0 0 1 1.846 1.23 3.01 3.01 0 0 0-1.646 1.69V10a.2.2 0 0 0-.2-.2ZM9.236 14c.433-.484.712-1.11.757-1.8h4.013c.046.69.324 1.316.758 1.8H9.236Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const PlanIcon = (props: any) => (
  <SvgIcon width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aPlanIcon)">
      <path
        fill="#717275"
        fillRule="evenodd"
        d="M9.375 3a.888.888 0 0 0-.875.9v1.8c0 .497.392.9.875.9h5.25a.888.888 0 0 0 .875-.9V3.9c0-.497-.392-.9-.875-.9h-5.25Zm-3.298.9h1.548v1.62h-1.05v13.86h10.85V5.52h-1.05V3.9h1.548c.595 0 1.077.383 1.077.855v15.39c0 .472-.482.855-1.077.855H6.077C5.482 21 5 20.617 5 20.145V4.755c0-.472.482-.855 1.077-.855Zm4.721 5.055a.429.429 0 0 0-.618 0l-.496.509a.46.46 0 0 0 0 .636l1.857 1.91c.17.175.447.175.618 0l2.475-2.546a.459.459 0 0 0 0-.637l-.495-.509a.429.429 0 0 0-.618 0l-1.362 1.4a.429.429 0 0 1-.618 0l-.743-.763Zm-.618 5.4a.429.429 0 0 1 .618 0l.743.763c.17.176.447.176.618 0l1.361-1.4a.429.429 0 0 1 .62 0l.494.51a.46.46 0 0 1 0 .636l-2.475 2.545a.429.429 0 0 1-.618 0L9.684 15.5a.46.46 0 0 1 0-.636l.496-.51Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="aPlanIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export const PlanIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aPlanIconBlue)">
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M9.375 3a.888.888 0 0 0-.875.9v1.8c0 .497.392.9.875.9h5.25a.888.888 0 0 0 .875-.9V3.9c0-.497-.392-.9-.875-.9h-5.25Zm-3.298.9h1.548v1.62h-1.05v13.86h10.85V5.52h-1.05V3.9h1.548c.595 0 1.077.383 1.077.855v15.39c0 .472-.482.855-1.077.855H6.077C5.482 21 5 20.617 5 20.145V4.755c0-.472.482-.855 1.077-.855Zm4.721 5.055a.429.429 0 0 0-.618 0l-.496.509a.46.46 0 0 0 0 .636l1.857 1.91c.17.175.447.175.618 0l2.475-2.546a.459.459 0 0 0 0-.637l-.495-.509a.429.429 0 0 0-.618 0l-1.362 1.4a.429.429 0 0 1-.618 0l-.743-.763Zm-.618 5.4a.429.429 0 0 1 .618 0l.743.763c.17.176.447.176.618 0l1.361-1.4a.429.429 0 0 1 .62 0l.494.51a.46.46 0 0 1 0 .636l-2.475 2.545a.429.429 0 0 1-.618 0L9.684 15.5a.46.46 0 0 1 0-.636l.496-.51Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const PlanIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aPlanIconGrey)">
      <path
        fill="#717275"
        fillRule="evenodd"
        d="M9.375 3a.888.888 0 0 0-.875.9v1.8c0 .497.392.9.875.9h5.25a.888.888 0 0 0 .875-.9V3.9c0-.497-.392-.9-.875-.9h-5.25Zm-3.298.9h1.548v1.62h-1.05v13.86h10.85V5.52h-1.05V3.9h1.548c.595 0 1.077.383 1.077.855v15.39c0 .472-.482.855-1.077.855H6.077C5.482 21 5 20.617 5 20.145V4.755c0-.472.482-.855 1.077-.855Zm4.721 5.055a.429.429 0 0 0-.618 0l-.496.509a.46.46 0 0 0 0 .636l1.857 1.91c.17.175.447.175.618 0l2.475-2.546a.459.459 0 0 0 0-.637l-.495-.509a.429.429 0 0 0-.618 0l-1.362 1.4a.429.429 0 0 1-.618 0l-.743-.763Zm-.618 5.4a.429.429 0 0 1 .618 0l.743.763c.17.176.447.176.618 0l1.361-1.4a.429.429 0 0 1 .62 0l.494.51a.46.46 0 0 1 0 .636l-2.475 2.545a.429.429 0 0 1-.618 0L9.684 15.5a.46.46 0 0 1 0-.636l.496-.51Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const DisplayIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M3.68 6.68a.5.5 0 0 1 .5-.5h14.64a.5.5 0 0 1 .5.5v7.26a.5.5 0 0 1-.5.5H4.18a.5.5 0 0 1-.5-.5V6.68ZM8 17.46a.34.34 0 0 1 .34-.34h6.32a.34.34 0 0 1 0 .68H8.34a.34.34 0 0 1-.34-.34Z"
      fill="#fff"
      stroke="#fff"
    />
  </svg>
)
export const DisplayIconBlue = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M4.512 6.47v8.102h14.976V6.47H4.512ZM3.9 5c-.497 0-.9.392-.9.875v9.292c0 .483.403.875.9.875h16.2c.497 0 .9-.392.9-.875V5.875A.888.888 0 0 0 20.1 5H3.9Zm5.256 12.53a.746.746 0 0 0-.756.735c0 .406.338.735.756.735h5.688c.418 0 .756-.33.756-.735a.746.746 0 0 0-.756-.735H9.156Z"
      clipRule="evenodd"
    />
  </svg>
)

export const DisplayIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M4.512 6.47v8.102h14.976V6.47H4.512ZM3.9 5c-.497 0-.9.392-.9.875v9.292c0 .483.403.875.9.875h16.2c.497 0 .9-.392.9-.875V5.875A.888.888 0 0 0 20.1 5H3.9Zm5.256 12.53a.746.746 0 0 0-.756.735c0 .406.338.735.756.735h5.688c.418 0 .756-.33.756-.735a.746.746 0 0 0-.756-.735H9.156Z"
      clipRule="evenodd"
    />
  </svg>
)

export const OpenWindowIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aOpenWindowIcon)">
      <path
        fill="#717275"
        d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z"
      />
    </g>
    <defs>
      <clipPath id="aOpenWindowIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const DashboardPaperIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#apaper)">
      <path
        d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="apaper">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const DashboardPaperBlackIcon = (props: any) => (
  <SvgIcon width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#ablackpaper)">
      <path
        d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z"
        fill="#404042"
      />
    </g>
    <defs>
      <clipPath id="ablackpaper">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)
export const DashboardPaperGreyIcon = (props: any) => (
  <SvgIcon width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aDashboardPaperGreyIcon)">
      <path
        d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7ZM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7Z"
        fill="#C8C9CC"
      />
    </g>
    <defs>
      <clipPath id="aDashboardPaperGreyIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export const DashboardIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aDashboardIcon)">
      <path
        fill="#717275"
        d="M3 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H3Zm2.468 1.684a.5.5 0 0 1 .5.5V7.47a.5.5 0 0 1-.5.5H4.18a.5.5 0 0 1-.5-.5V6.184a.5.5 0 0 1 .5-.5h1.287ZM4.18 13.143a.5.5 0 0 1-.5-.5v-1.286a.5.5 0 0 1 .5-.5h1.287a.5.5 0 0 1 .5.5v1.286a.5.5 0 0 1-.5.5H4.18Zm-.5 3.385a.5.5 0 0 1 .5-.5h1.287a.5.5 0 0 1 .5.5v1.286a.5.5 0 0 1-.5.5H4.18a.5.5 0 0 1-.5-.5v-1.286Zm16.634 1.286a.5.5 0 0 1-.5.5H8.151a.5.5 0 0 1-.5-.5v-1.286a.5.5 0 0 1 .5-.5h11.664a.5.5 0 0 1 .5.5v1.286Zm0-5.171a.5.5 0 0 1-.5.5H8.151a.5.5 0 0 1-.5-.5v-1.286a.5.5 0 0 1 .5-.5h11.664a.5.5 0 0 1 .5.5v1.286Zm0-5.173a.5.5 0 0 1-.5.5H8.151a.5.5 0 0 1-.5-.5V6.184a.5.5 0 0 1 .5-.5h11.664a.5.5 0 0 1 .5.5V7.47Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const ProfileIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M5.574 13.165c.85-.777 1.65-1.307 3.038-1.307h3.386v1.68H8.612c-.604 0-1.249.351-1.795.817-.633.468-1.167 1.432-1.167 1.718v2.776c0 .437.044.502.48.502h5.872L12 20.997H5.324c-.669 0-1.324-.542-1.324-1.211v-3.713c0-1.358.725-2.132 1.574-2.908Z"
      fill="#404042"
    />
    <path
      d="M18.425 13.165c-.85-.776-1.649-1.307-3.037-1.307h-3.39v1.68l3.39.001c.604 0 1.249.35 1.795.817.633.467 1.166 1.432 1.166 1.718v2.775c0 .437-.043.502-.48.502h-5.871v1.647h6.678c.668 0 1.324-.543 1.324-1.212v-3.712c0-1.359-.726-2.133-1.575-2.909Z"
      fill="#404042"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.994 8.522a2.435 2.435 0 1 0 0-4.87 2.435 2.435 0 0 0 0 4.87Zm0 1.652a4.088 4.088 0 1 0 0-8.175 4.088 4.088 0 0 0 0 8.175Z"
      fill="#404042"
    />
  </svg>
)

export const CompanyInfoIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aCompany)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.8 4.8V8H7V4.8H4.8Zm0 4.9H7V13H4.8V9.7Zm3.9 0V13h2.5V9.7H8.7Zm-3.9 5H7v4.5H4.8v-4.5Zm3.9 0v4.5h2.5v-4.5H8.7Zm0-9.9V8h2.5V4.8H8.7ZM4 3a1 1 0 0 0-1 1v17h10V4a1 1 0 0 0-1-1H4Zm15.3 5.7h-4.6V7H20a1 1 0 0 1 1 1v13h-6.3v-1.7h4.6V8.7Z"
        fill="#404042"
      />
    </g>
    <defs>
      <clipPath id="aCompany">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const LogoutIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M16.645 2H5.005C4.45 2 4 2.448 4 3v18c0 .552.45 1 1.006 1h11.639c.555 0 1.006-.448 1.006-1v-4.912h-1.674v3.24c0 .552-.45 1-1.006 1H6.694a1.003 1.003 0 0 1-1.006-1V4.709c0-.55.448-.997 1.002-1l8.276-.045a1.003 1.003 0 0 1 1.01 1V7.93h1.675V3c0-.552-.45-1-1.006-1Z"
      fill="#404042"
    />
    <path
      d="M13.96 12.324c0 .221.18.4.403.4h5.345l-.668.825a.398.398 0 0 0 .051.555l.483.412a.404.404 0 0 0 .577-.053l1.761-2.192a.398.398 0 0 0 .003-.497L20.155 9.54a.404.404 0 0 0-.57-.064l-.482.388a.398.398 0 0 0-.069.551l.673.891-5.343-.017a.401.401 0 0 0-.405.4v.635Z"
      fill="#404042"
    />
  </svg>
)

export const ShareableIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#404042"
      fillRule="evenodd"
      d="M18.114 3a2.884 2.884 0 0 0-2.86 3.261l-4.8 2.768a4.227 4.227 0 0 0-3.22-1.484A4.232 4.232 0 0 0 3 11.774a4.231 4.231 0 0 0 4.234 4.229 4.223 4.223 0 0 0 2.947-1.193l5.061 2.919A2.884 2.884 0 0 0 18.102 21a2.884 2.884 0 0 0 2.885-2.882 2.884 2.884 0 0 0-2.885-2.883c-.923 0-1.744.433-2.272 1.105l-4.77-2.752a4.21 4.21 0 0 0 .408-1.814c0-.51-.09-.999-.256-1.451l4.627-2.669a2.882 2.882 0 0 0 2.275 1.11A2.884 2.884 0 0 0 21 5.883 2.884 2.884 0 0 0 18.114 3Zm-13.61 8.774a2.728 2.728 0 0 1 2.73-2.727c1.508 0 2.73 1.22 2.73 2.727a2.728 2.728 0 0 1-2.73 2.727 2.728 2.728 0 0 1-2.73-2.727Zm11.991-5.892a1.608 1.608 0 1 1 3.216.002 1.608 1.608 0 0 1-3.216-.002Zm.233 12.236a1.373 1.373 0 1 1 2.746.001 1.373 1.373 0 0 1-2.746-.001Z"
      clipRule="evenodd"
    />
  </svg>
)

export const ShareableWhiteIcon = (props: any) => (
  <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.794 0a3.204 3.204 0 0 0-3.179 3.624L8.283 6.699a4.696 4.696 0 0 0-3.579-1.65A4.702 4.702 0 0 0 0 9.75c0 2.595 2.106 4.699 4.704 4.699a4.692 4.692 0 0 0 3.275-1.326l5.623 3.243A3.204 3.204 0 0 0 16.78 20a3.204 3.204 0 0 0 3.207-3.203 3.204 3.204 0 0 0-3.207-3.202c-1.024 0-1.936.48-2.523 1.227l-5.301-3.057a4.678 4.678 0 0 0 .454-2.016c0-.567-.1-1.11-.285-1.613l5.141-2.965a3.202 3.202 0 0 0 2.529 1.234A3.204 3.204 0 0 0 20 3.203 3.204 3.204 0 0 0 16.794 0ZM1.67 9.748a3.031 3.031 0 0 1 3.033-3.03 3.031 3.031 0 0 1 3.034 3.03 3.031 3.031 0 0 1-3.034 3.03 3.031 3.031 0 0 1-3.033-3.03Zm13.324-6.545a1.787 1.787 0 1 1 3.573.002 1.787 1.787 0 0 1-3.574-.002Zm.258 13.594a1.526 1.526 0 1 1 3.051.002 1.526 1.526 0 0 1-3.05-.002Z"
      fill="#ffffff"
    />
  </svg>
)

export const OptionIcon = (props: any) => (
  <svg width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      d="M9.999 13.263a1.26 1.26 0 1 1 0 2.52 1.26 1.26 0 0 1 0-2.52ZM11.259 10.002a1.26 1.26 0 1 0-2.52 0 1.26 1.26 0 0 0 2.52 0ZM9.999 4.216a1.26 1.26 0 1 1 0 2.52 1.26 1.26 0 0 1 0-2.52Z"
      fill="#404042"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-1.68 0a8.32 8.32 0 1 0-16.64 0 8.32 8.32 0 0 0 16.64 0Z"
      fill="#404042"
    />
  </svg>
)

export const TestServiceIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aTestServiceIcon)" fill="#404042">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 3H3c-.496 0-1 .5-1 1v16c0 .504.504 1 1 1h18c.5 0 1-.496 1-1V4c0-.502-.504-1-1-1Zm-.68 15.32a1 1 0 0 1-1 1H4.68a1 1 0 0 1-1-1V5.68a1 1 0 0 1 1-1h14.64a1 1 0 0 1 1 1v12.64Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.41 10.42 17.99 9l-3.17 3.17-1.41-1.42L12 12.16 14.82 15l4.59-4.58Z"
      />
      <path d="M10 7H5v2h5V7ZM10 11H5v2h5v-2ZM10 15H5v2h5v-2Z" />
    </g>
    <defs>
      <clipPath id="aTestServiceIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const WidgetIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aWidgetIcon)">
      <path
        d="M16.306 4.553a.5.5 0 0 1 .708 0l2.442 2.443a.5.5 0 0 1 0 .707l-2.442 2.443a.5.5 0 0 1-.708 0l-2.442-2.443a.5.5 0 0 1 0-.707l2.442-2.443ZM8.82 4.68a.5.5 0 0 1 .5.5v3.64a.5.5 0 0 1-.5.5H5.18a.5.5 0 0 1-.5-.5V5.18a.5.5 0 0 1 .5-.5h3.64Zm10 10a.5.5 0 0 1 .5.5v3.64a.5.5 0 0 1-.5.5h-3.64a.5.5 0 0 1-.5-.5v-3.64a.5.5 0 0 1 .5-.5h3.64Zm-10 0a.5.5 0 0 1 .5.5v3.64a.5.5 0 0 1-.5.5H5.18a.5.5 0 0 1-.5-.5v-3.64a.5.5 0 0 1 .5-.5h3.64Zm8.546-12.285a1 1 0 0 0-1.412 0l-4.246 4.238a1 1 0 0 0 0 1.415l4.245 4.245a1 1 0 0 0 1.414 0l4.245-4.245a1 1 0 0 0 0-1.415l-4.245-4.238ZM11 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4Zm10 10a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6Zm-10 0a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6Z"
        fill="#404042"
      />
    </g>
    <defs>
      <clipPath id="aWidgetIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const ApplinkIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      d="M3.69 12c0-1.71 1.6-3.32 3.31-3.32h3.5a.5.5 0 0 0 .5-.5V7.5a.5.5 0 0 0-.5-.5H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3.5a.5.5 0 0 0 .5-.5v-.676a.5.5 0 0 0-.5-.5H7c-1.71 0-3.31-1.614-3.31-3.324Zm4.31.342a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.682a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v.682ZM17 7h-3.5a.5.5 0 0 0-.5.5v.68a.5.5 0 0 0 .5.5H17c1.71 0 3.333 1.61 3.333 3.32 0 1.71-1.623 3.324-3.333 3.324h-3.5a.5.5 0 0 0-.5.5v.676a.5.5 0 0 0 .5.5H17c2.76 0 5-2.24 5-5s-2.24-5-5-5Z"
      fill="#404042"
    />
  </svg>
)
export const ExportIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#aexport)" fill="#404042">
      <path d="M19.32 19.82a.5.5 0 0 1-.5.5H5.18a.498.498 0 0 1-.5-.497V12.18a.5.5 0 0 1 .5-.5H8.5a.5.5 0 0 0 .5-.5v-.68a.5.5 0 0 0-.5-.5H4c-.552 0-1 .445-1 .997v10.007c0 .553.443.996.996.996H20A.999.999 0 0 0 21 21V11a1 1 0 0 0-1-1h-4.5a.5.5 0 0 0-.5.5v.68a.5.5 0 0 0 .5.5h3.32c.276 0 .5.22.5.497v7.643Z" />
      <path d="M7.35 6.643a.5.5 0 0 0 0 .707l.703.703a.5.5 0 0 0 .707 0l2.236-2.227v8.67a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-8.67l2.226 2.236a.5.5 0 0 0 .708 0l.712-.712a.5.5 0 0 0 0-.707l-3.939-4.346a1 1 0 0 0-1.414 0l-3.94 4.345Z" />
    </g>
    <defs>
      <clipPath id="aexport">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const CreateServiceSuccessIcon = (props: any) => (
  <svg width={444} height={272} fill="none" {...props}>
    <path fill="#4388FF" d="M0 0h444v272H0z" />
    <mask
      id="a"
      width={444}
      height={265}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M0 0h444v265H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M289.318 19.144c.897 3.026-.824 6.157-3.843 6.995-3.02.837-6.195-.937-7.092-3.963-.897-3.025.824-6.156 3.843-6.994 3.019-.837 6.194.937 7.092 3.962Zm1.447 13.436-1.918-6.47s-1.409 1.174-2.91 1.59c-1.5.416-3.337.148-3.337.148l1.917 6.465 2.471-3.072 3.777 1.339ZM296.9 157.394c1.37 4.618-1.303 9.411-5.97 10.705-4.666 1.294-9.559-1.401-10.928-6.019-1.37-4.618 1.303-9.41 5.97-10.704 4.666-1.294 9.559 1.4 10.928 6.018Zm2.166 20.52-2.928-9.875s-2.182 1.8-4.501 2.443c-2.318.642-5.153.243-5.153.243l2.926 9.867 3.83-4.705 5.826 2.027ZM407.363 56.708c-1.696 7.102-8.935 11.55-16.169 9.935-7.234-1.615-11.724-8.682-10.029-15.784 1.696-7.102 8.935-11.55 16.169-9.935 7.234 1.615 11.724 8.682 10.029 15.784Zm-12.779 28.76 3.626-15.187s-4.296.828-7.891.026c-3.594-.803-7.082-3.356-7.082-3.356l-3.623 15.174 8.721-3.505 6.249 6.847Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillOpacity={0.032}
        d="m150.726 15 46.89 42.284-43.726 45.344L107 60.344z"
      />
      <path
        fill="#000"
        fillOpacity={0.03}
        d="m329.676 262.48 37.814 34.1-35.262 36.568-37.814-34.1zM219.487 218.2l24.201 21.824-22.568 23.403-24.201-21.824zM206.044 75.2l24.201 21.824-22.568 23.403-24.201-21.823zM240.169 62.2l24.201 21.824-22.568 23.403-24.201-21.823zM166.748 247.2l24.201 21.824-22.568 23.403-24.201-21.824z"
      />
      <path
        fill="#000"
        fillOpacity={0.02}
        d="m239.135 93.2 24.201 21.824-22.568 23.403-24.201-21.823z"
      />
      <path
        fill="#000"
        fillOpacity={0.036}
        d="m299.112 187.2 24.201 21.824-22.568 23.403-24.201-21.824z"
      />
      <path
        fill="#fff"
        fillOpacity={0.04}
        d="m274.294 134.2 24.201 21.824-22.568 23.403-24.201-21.824zM178.123 99.2l24.201 21.824-22.568 23.403-24.201-21.823zM271.6 9.507l12.1 10.912-11.283 11.701-12.101-10.911zM263.532 28.16l6.05 5.456-5.642 5.851-6.05-5.456z"
      />
      <path
        fill="#fff"
        fillOpacity={0.03}
        d="m300.568 219.24 42.352 38.192-39.494 40.956-42.352-38.192z"
      />
      <path
        fill="#fff"
        fillOpacity={0.04}
        d="m249.692 225.587 48.402 43.648-45.136 46.807-48.402-43.648zM172.136 141.587l48.402 43.648-45.136 46.807L127 188.394zM256.51 157.547l30.251 27.28-28.21 29.254-30.251-27.28zM255.477 27.547l30.251 27.28-28.21 29.254-30.251-27.28z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m246.271 135.352-3.163-2.209-1.797 2.435 5.647 3.967 8.791-11.701-2.493-1.799-6.985 9.307Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m276.43 212.281-3.159-4.247-3.516 2.374 5.628 7.614 17.103-11.343-2.462-3.423-13.594 9.025Z"
        clipRule="evenodd"
        opacity={0.198}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m200.644 87.674-1.227-2.217-1.813.951 2.185 3.973 8.804-4.527-.95-1.782-6.999 3.602ZM351.187 253.856l-2.141 4.651-4.81-2.071-.832 1.809 4.809 2.07-2.141 4.651 1.87.806 2.142-4.651 4.809 2.07.833-1.808-4.81-2.071 2.142-4.651-1.871-.805ZM170.221 215.856l-2.141 4.651-4.809-2.071-.833 1.809 4.809 2.07-2.141 4.651 1.87.806 2.142-4.651 4.809 2.07.833-1.808-4.81-2.071 2.142-4.651-1.871-.805ZM222.961 4.856l-2.142 4.65-4.809-2.07-.833 1.809 4.81 2.07-2.142 4.651 1.871.806 2.141-4.651 4.81 2.07.832-1.808-4.809-2.071 2.141-4.651-1.87-.805ZM317.916 204.022l14.555 3.772c1.213.314 2.104 1.787 1.783 2.947l-5.139 18.545c-.321 1.159-1.855 2.004-3.068 1.69l-14.554-3.771 6.423-23.183Zm.892 1.474 13.342 3.457c.494.128 1.017 1.02.891 1.474l-5.138 18.545c-.136.489-1.06.968-1.535.845l-13.341-3.457 5.781-20.864Zm9.239 13.575c-.71 2.56-3.457 4.073-6.137 3.379-2.679-.694-4.276-3.333-3.567-5.894.71-2.56 3.457-4.073 6.137-3.379 2.679.694 4.276 3.333 3.567 5.894Zm-3.815-.371c-.466 1.268-1.412 2.12-1.834 2.011-.421-.11-.803-1.043-.548-2.628l2.382.617Zm2.398.627-1.19-.309c-.303.726-.571 1.275-1.01 1.764-.439.49-.587.578-.587.578s.561-.079 1.174-.385c.613-.306 1.172-.814 1.613-1.648Zm-.869-1.469 1.181.307c.061-.79-.118-1.384-.245-1.662-.442-.968-1.105-1.453-1.105-1.453s.231.67.262 1.127a7.14 7.14 0 0 1-.093 1.681Zm-5.124-.084-1.189-.308c-.087.975.208 1.656.527 2.188.32.531.821.923.821.923s-.189-.485-.258-1.108c-.032-.298-.034-1.212.099-1.695Zm1.53-.845c.43-1.219 1.389-2.117 1.828-2.003.44.114.839 1.313.543 2.617l-2.371-.614Zm-1.338-1.933c.699-.551 1.713-.733 1.713-.733s-.734.652-1.057 1.241a11.35 11.35 0 0 0-.533 1.11l-1.181-.306s.358-.762 1.058-1.312ZM243.41 53.07l22.762-3.487c1.897-.29 4.085 1.197 4.376 2.975l4.659 28.445c.291 1.778-1.315 3.846-3.211 4.137l-22.762 3.486-5.824-35.557Zm2.189 1.487 20.864-3.196c.774-.118 2.075.792 2.188 1.487l4.659 28.446c.123.749-.863 1.954-1.605 2.068l-20.865 3.196-5.241-32.001Zm21.588 13.095c.643 3.928-2.233 7.632-6.423 8.274-4.19.642-8.109-2.022-8.752-5.95-.643-3.927 2.232-7.631 6.423-8.273 4.19-.642 8.108 2.022 8.752 5.95Zm-5.573 1.76c.159 2.012-.62 3.741-1.279 3.842-.66.101-1.789-.95-2.445-3.272l3.724-.57Zm3.755-.567-1.861.285c.04 1.174.015 2.084-.286 3.016-.301.931-.451 1.14-.451 1.14s.734-.443 1.396-1.226c.661-.783 1.119-1.811 1.202-3.215Zm-2.154-1.494 1.848-.283c-.42-1.116-1.049-1.823-1.404-2.128-1.237-1.063-2.474-1.334-2.474-1.334s.752.78 1.086 1.388c.335.607.706 1.448.944 2.357Zm-7.217 2.928-1.861.285c.502 1.387 1.35 2.145 2.136 2.683.785.538 1.737.776 1.737.776s-.574-.552-1.069-1.364c-.236-.389-.822-1.64-.943-2.38Zm1.599-2.065c-.177-1.924.59-3.723 1.277-3.829.687-.105 2.011 1.3 2.43 3.261l-3.707.568Zm-3.108-1.85c.627-1.17 1.928-2.023 1.928-2.023s-.609 1.33-.685 2.328c-.077.999-.037 1.836-.037 1.836l-1.847.283s.015-1.255.641-2.425ZM397.964 191h14.891c2.481 0 4.963 2.4 4.963 4.8v7.2H393v-7.2c0-2.4 2.482-4.8 4.964-4.8Zm0 1.2h14.891c1.77 0 3.722 1.943 3.722 3.6v6h-22.336v-6c0-1.833 1.903-3.6 3.723-3.6Zm12.409-8.4c0 2.651-2.222 4.8-4.963 4.8-2.742 0-4.964-2.149-4.964-4.8s2.222-4.8 4.964-4.8c2.741 0 4.963 2.149 4.963 4.8Zm-1.24 0c0 1.989-1.667 3.6-3.723 3.6s-3.723-1.611-3.723-3.6c0-1.988 1.667-3.6 3.723-3.6s3.723 1.612 3.723 3.6ZM173.549 32.807l20.568 2.09-1.513 13.924-20.568-2.091 1.513-13.923Zm9.313 9.987 10.073-6.581-1.251 11.508-18.512-1.881 1.25-11.499 8.44 8.453Zm9.046-7.116-16.376-1.664 7.466 7.477 8.91-5.813ZM60.682 36H40v14h20.682V36Zm-1.034 1H41.034v12h18.614V37Zm-13.96 4c.856 0 1.55-.671 1.55-1.5 0-.828-.694-1.5-1.55-1.5-.857 0-1.551.672-1.551 1.5 0 .829.694 1.5 1.55 1.5Zm0 0h1.551c1.035 0 2.069 1 2.069 2v2h-7.239v-2c0-1 1.073-2 2.068-2h1.55Zm.517-1.5c0 .276-.231.5-.517.5a.509.509 0 0 1-.517-.5c0-.276.232-.5.517-.5.286 0 .517.224.517.5Zm.592 2.5c1.009 0 1.477.21 1.477 1v1h-5.17v-1c0-.773.584-1 1.477-1h2.215Zm11.818-2h-7.239v1h7.239v-1Zm-7.239 3h5.17v1h-5.17v-1Zm6.205 3h-6.205v1h6.205v-1ZM241.983 216.704c.385 1.615-.656 3.226-2.325 3.598-1.67.373-3.336-.634-3.721-2.248-.385-1.614.655-3.225 2.325-3.598 1.669-.373 3.335.634 3.721 2.248Zm-1.008.225c.257 1.076-.437 2.15-1.55 2.398-1.113.249-2.224-.422-2.481-1.498-.256-1.077.437-2.151 1.55-2.399 1.113-.248 2.224.423 2.481 1.499Zm-5.112 5.246 8.069-1.801c2.017-.45 4.483 1.052 4.948 3l.931 3.898-16.122 3.599-.93-3.897c-.465-1.949 1.087-4.348 3.104-4.799Zm8.289-.824-8.061 1.799c-1.642.367-2.662 2.186-2.325 3.598l.698 2.923 14.106-3.149-.698-2.923c-.359-1.507-2.378-2.548-3.72-2.248Zm-1.861-7.794 8.061-1.8 1.395 5.846-8.06 1.8-1.396-5.846Zm7.285-.601-6.045 1.35.93 3.897 6.046-1.35-.931-3.897ZM164.801 110.831l-13.226 5.694 8.412 18.271 13.226-5.694-8.412-18.271Zm-.524 1.32-11.336 4.881 7.57 16.444 11.337-4.881-7.571-16.444Zm-8.606 5.895 7.558-3.254.42.914-7.557 3.253-.421-.913Zm2.731 1.014-1.89.813.421.914 1.889-.814-.42-.913Zm.944-.408 4.724-2.033.42.913-4.723 2.034-.421-.914Zm2.731 1.015-4.723 2.033.42.914 4.724-2.034-.421-.913Zm-3.462 4.773 5.668-2.44.421.914-5.668 2.44-.421-.914Zm7.454-1.02-6.613 2.848.421.913 6.613-2.847-.421-.914Zm-5.772 4.675 3.779-1.627.421.913-3.779 1.627-.421-.913Zm7.559-3.254-2.834 1.221.42.913 2.834-1.22-.42-.914Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M85.861 225.513 65.981 220 58 246.915l19.88 5.513 7.981-26.915Zm-1.819.951-17.04-4.725-7.183 24.224 17.04 4.725 7.183-24.224Zm-14.998-1.245 11.36 3.15-.399 1.346-11.36-3.15.399-1.346Zm2.042 3.479-2.84-.788-.4 1.346 2.84.787.4-1.345Zm1.42.394 7.1 1.969-.4 1.345-7.1-1.968.4-1.346Zm2.041 3.478-7.1-1.968-.399 1.345 7.1 1.969.4-1.346Zm-8.297 2.069 8.52 2.362-.398 1.346-8.52-2.363.398-1.345Zm9.143 5.447-9.94-2.756-.4 1.346 9.94 2.756.4-1.346Zm-10.74-.064 5.681 1.576-.399 1.345-5.68-1.575.399-1.346Zm11.361 3.151-4.26-1.182-.399 1.346 4.26 1.181.4-1.345Z"
        clipRule="evenodd"
        opacity={0.2}
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m58.667 133.845-20.302-3.816c-1.017-.191-2.23.609-2.415 1.532l-6.926 34.455c-.177.884.637 2.107 1.646 2.296l20.302 3.816c1.037.195 2.213-.527 2.415-1.532l6.925-34.455c.194-.964-.548-2.09-1.645-2.296Zm-2.415 1.533-16.242-3.053c-1.034-.195-1.541-.29-1.841-.084-.289.199-.385.677-.574 1.616l-.384 1.914 20.301 3.817.382-1.899c.19-.949.288-1.432.095-1.722-.199-.3-.706-.396-1.737-.589Zm-19.425 2.307 20.302 3.816-4.617 22.97-20.302-3.816 4.617-22.97Zm15.299 28.7-20.302-3.816-.387 1.923c-.187.933-.283 1.409-.093 1.697.197.3.705.395 1.74.59l16.242 3.053c1.034.194 1.542.29 1.841.083.29-.198.385-.677.574-1.616l.385-1.914Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F0F0F0"
      fillRule="evenodd"
      d="M89 65.79a3.87 3.87 0 0 1 3.87-3.87h176.006a3.87 3.87 0 0 1 3.871 3.87v114.756a3.87 3.87 0 0 1-3.871 3.871H92.871A3.87 3.87 0 0 1 89 180.546V65.79Z"
      clipRule="evenodd"
    />
    <path
      fill="#2D426B"
      fillRule="evenodd"
      d="M89 65.79a3.87 3.87 0 0 1 3.87-3.87h176.006a3.87 3.87 0 0 1 3.871 3.87v93.107H89V65.79Z"
      clipRule="evenodd"
      opacity={0.877}
    />
    <path
      fill="#F0F0F0"
      fillRule="evenodd"
      d="M160.457 184.417h40.833L205.373 213h-48.999l4.083-28.583Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.099}
      fillRule="evenodd"
      d="M160.457 184.417h40.832l-42.398 10.963 1.566-10.963Z"
      clipRule="evenodd"
    />
    <g filter="url(#b)">
      <path fill="#fff" d="M138.053 53.216h216.214v113.748H138.053z" />
      <path
        fill="#D8D8D8"
        d="M151.977 99.42h189.884v-.632H151.977zM151.977 119.042h189.884v-.633H151.977zM151.977 138.664h189.884v-.633H151.977zM151.977 158.285h189.884v-.633H151.977z"
      />
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M165.902 86.762a2.531 2.531 0 1 1-5.063 0 2.531 2.531 0 0 1 5.063 0Zm3.798 3.798h-12.659v5.064H169.7V90.56ZM166.534 105.751a2.531 2.531 0 1 1-5.062.002 2.531 2.531 0 0 1 5.062-.002Zm3.798 3.798h-12.659v5.064h12.659v-5.064Z"
        clipRule="evenodd"
      />
      <path fill="#FAA43A" d="M181.092 87.397h19.621v3.798h-19.621z" />
      <path fill="#404142" d="M215.904 87.397h31.647v3.798h-31.647z" />
      <path fill="#77797A" d="M262.742 87.397h44.939v3.798h-44.939z" />
      <path
        fill="#404142"
        d="M317.176 87.397h18.988v3.798h-18.988zM317.176 107.018h18.988v3.798h-18.988zM317.176 126.006h18.988v3.798h-18.988zM317.176 146.26h18.988v3.798h-18.988z"
      />
      <path
        fill="#77797A"
        d="M262.742 107.018h44.939v3.798h-44.939zM262.742 126.006h44.939v3.798h-44.939zM262.742 146.26h44.939v3.798h-44.939z"
      />
      <path
        fill="#404142"
        d="M215.904 107.018h31.647v3.798h-31.647zM215.904 126.006h31.647v3.798h-31.647zM215.904 146.26h31.647v3.798h-31.647z"
      />
      <path fill="#FAA43A" d="M181.092 107.018h19.621v3.798h-19.621z" />
      <path fill="#41BF58" d="M181.092 126.639h19.621v3.798h-19.621z" />
      <path fill="#FF334B" d="M181.092 146.26h19.621v3.798h-19.621z" />
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M166.534 125.372a2.531 2.531 0 1 1-5.062.002 2.531 2.531 0 0 1 5.062-.002Zm3.798 3.798h-12.659v5.064h12.659v-5.064ZM166.534 145.627a2.532 2.532 0 1 1-5.064 0 2.532 2.532 0 0 1 5.064 0Zm3.798 3.798h-12.659v5.063h12.659v-5.063Z"
        clipRule="evenodd"
      />
      <path
        fill="#D8D8D8"
        d="M151.977 79.8h189.884v-7.595H151.977z"
        opacity={0.248}
      />
      <path fill="#404142" d="M138.053 53.216h216.214v11.281H138.053z" />
      <path
        fill="#FF334B"
        fillRule="evenodd"
        d="M143.693 60.737a1.88 1.88 0 1 0 0-3.761 1.88 1.88 0 0 0 0 3.76Z"
        clipRule="evenodd"
      />
      <path
        fill="#FAA43A"
        fillRule="evenodd"
        d="M149.333 60.737a1.88 1.88 0 1 0 0-3.76 1.88 1.88 0 0 0 0 3.76Z"
        clipRule="evenodd"
      />
      <path
        fill="#41BF58"
        fillRule="evenodd"
        d="M154.974 60.737a1.88 1.88 0 1 0 0-3.761 1.88 1.88 0 0 0 0 3.76Z"
        clipRule="evenodd"
      />
    </g>
    <g filter="url(#c)">
      <path
        fill="#EBF2FF"
        fillRule="evenodd"
        d="M182.615 119.372a33.497 33.497 0 0 1-22.016 8.21c-18.569 0-33.622-15.054-33.622-33.623 0-18.569 15.053-33.622 33.622-33.622s33.622 15.053 33.622 33.622c0 8.421-3.095 16.118-8.21 22.016l29.462 29.462a2.402 2.402 0 0 1-3.396 3.397l-29.462-29.462Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="d"
      width={67}
      height={66}
      x={127}
      y={61}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M160.598 126.789c18.131 0 32.83-14.699 32.83-32.83 0-18.132-14.699-32.83-32.83-32.83-18.132 0-32.83 14.698-32.83 32.83 0 18.131 14.698 32.83 32.83 32.83Z"
        clipRule="evenodd"
      />
    </mask>
    <g filter="url(#e)" mask="url(#d)">
      <path fill="#fff" d="M85.835-29.857h583.779v307.118H85.835z" />
      <path fill="#D8D8D8" d="M134.099 118.668h56.174v-2.374h-56.174z" />
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M161.03 84.215a6.836 6.836 0 1 1-13.672 0 6.836 6.836 0 0 1 13.672 0Zm-17.811 9.927a2 2 0 0 0-2 2v10.242a2 2 0 0 0 2 2h22.109a2 2 0 0 0 2-2V96.142a2 2 0 0 0-2-2h-22.109Z"
        clipRule="evenodd"
      />
      <path
        fill="#D8D8D8"
        d="M123.433 65.416h512.686V44.91H123.433z"
        opacity={0.248}
      />
    </g>
    <defs>
      <filter
        id="b"
        width={248.214}
        height={145.748}
        x={122.053}
        y={39.216}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={8} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0974924 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13382_23879"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_13382_23879"
          result="shape"
        />
      </filter>
      <filter
        id="c"
        width={113.2}
        height={113.2}
        x={114.977}
        y={50.337}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={6} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.195995 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13382_23879"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_13382_23879"
          result="shape"
        />
      </filter>
      <filter
        id="e"
        width={669.778}
        height={393.185}
        x={42.835}
        y={-67.857}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={21.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0974924 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_13382_23879"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_13382_23879"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export const SelectedCheckIcon = (props: any) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M8.585 12.529a.833.833 0 0 1-1.178 0L3.92 9.054a.833.833 0 0 0-1.177.001l-.04.04a.833.833 0 0 0 0 1.18l4.705 4.693a.833.833 0 0 0 1.178 0L17.3 6.252a.833.833 0 0 0 0-1.179l-.04-.04a.833.833 0 0 0-1.178 0l-7.497 7.495Z"
      clipRule="evenodd"
    />
  </svg>
)
export const CreateServiceCheckIcon = (props: any) => (
  <svg width={200} height={200} fill="none" {...props}>
    <path fill="url(#aa)" d="M0 0h200v200H0z" />
    <defs>
      <pattern
        id="aa"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#bb" transform="scale(.0025)" />
      </pattern>
      <image
        id="bb"
        width={400}
        height={400}
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
)
export const CreateServiceIcon = (props: any) => (
  <svg width={290} height={304} fill="none" {...props}>
    <mask
      id="acreate"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={290}
      height={304}
    >
      <path fill="#4388FF" d="M0 0h290v304H0z" />
    </mask>
    <g mask="url(#acreate)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m102.959 304.047 123.932-37.365h18.987l-116.023 37.599-26.896-.234Z"
        fill="#669EFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m25.71 230.756 263.761-20.695 1.925 38.377-189.015 55.495H26l-.29-73.177Z"
        fill="#98BEFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m187.709 242.6 46.116 10.402-96.236 14.762-74.649-14.387L187.71 242.6Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M274.41 93.478h33.433v38.044s-35.326 10.952-48.677 4.918c5.91-7.649 15.244-12.416 15.244-12.416V93.478Z"
        fill="#FF8780"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.777 52.383V40.53c0-13.401 23.55-14.664 33.433-14.664 12.717 0 33.816 5.764 33.816 26.515 0 8.39-10.183 8.038-10.183 22.073v32.111h-23.441c-29.236 0-33.625-30.829-33.625-30.829V52.383Z"
        fill="#FF8780"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M250.816 45.937c0-2.322-.477-7.188-.039-8.96 3.865-15.627 24.002-11.109 33.432-11.109 12.718 0 37.994 5.72 37.994 26.472 0 6.893-18.299 45.435-18.299 45.435s-7.304-3.766-9.845-6.236c-4.599-4.471-6.762-9.943-6.365-10.359 4.164-4.353 3.242-12.492-.364-13.065-2.08-.33-3.11.588-3.849 1.523-.05.063-.01 20.424-2.111 22.048-7.663 5.925-9.967 6.075-20.156 7.181-.916-.725-1.603-1.333-2.062-1.823-2.797-2.989-3.707-4.925-4.213-7.271 1.468-.246 23.141-1.032 24.363-4.135.83-2.108 2.18-3.4 2.126-5.828 0 0-1.738-26.238-2.301-26.726-1.384-1.2-2.175.295-3.414 0-.016-1.828-4.685-6.23-5.409-7.147-.724-.916-17.034 1.963-19.488 0Z"
        fill="#613488"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M287.84 81.283c4.164-4.353 3.241-12.493-.365-13.065-2.079-.33-3.11.588-3.849 1.522.996-2.336 6.595-5.453 7.979-1.056 1.384 4.397.361 9.981-3.765 12.599Z"
        fill="#000"
        fillOpacity={0.097}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M319.885 62.694s-9.995-3.263-11.784-5.22c-1.675-1.832-9.766-2.728-11.382-4.206-4.563-4.174-5.205-3.396-10.002-4.455-4.358 0-8.602-5.267-18.313-7.54-5.392-1.269-15.298.746-17.862-.893-.585-.374-1.594-5.257-1.494-7.887.066-1.747 1.069-2.503 1.494-4.92.247-1.406-.534-4.646 0-6.168.707-2.018 3.054-2.981 4.401-5.07 1.384-2.147 4.204-2.957 7.551-2.787 1.039.053 2.011 1.093 3.158 1.074 2.068-.034 4.153-1.763 6.409-2.12 2.933-.466 8.203-1.812 11.072-2.197 2.647-.356 22.221 4.839 24.71 6.03 2.83 1.356 8.678 9.502 10.329 12.584 1.223 2.284 2.331 4.778 4.032 7.14.666.925 1.28 2.867 1.899 4.32.7 1.644 1.377 2.82 1.633 4.12.877 4.449 1.154 9.367-1.003 10.735-1.059.672.229 7.187-1.913 9.145-1.165 1.064-2.935-1.685-2.935-1.685Z"
        fill="#500D88"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M253.849 28.226s10.651.722 11.138 1.977c.487 1.256-8.859.492-3.088 3.34 5.771 2.849 13.995 2.767 18.93 4.707 4.935 1.94 22.657 9.592 22.657 9.592s-16.867-9.168-22.267-12.015c-5.4-2.847-13.153-2.534-14.414-3.142-1.261-.608 7.441.897 4.521-1.629-.937-.81-15.906-7.819-17.601-6.674-1.695 1.145.124 3.843.124 3.843Z"
        fill="#000"
        fillOpacity={0.198}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M272.107 17.269s-2.304-1.043-4.29.068c-.087.048 5.187 3.434 6.823 4.956 1.738 1.616.563 5.329 1.299 6.072.729.734 8.732-2.533 8.732-2.533s1.199 3.498 2.608 5.946c1.409 2.448 8.772 2.872 8.772 2.872s5.989 1.62 8.111 5.897c.792 1.598 2.041 3.678 3.745 6.24 1.337 2.008 7.855 4.53 7.855 4.53s-5.749-3.61-6.804-6.115c-.953-2.261-1.734-4.255-2.342-5.982-1.924-5.46-5.688-2.766-8.77-6.785-3.082-4.02-7.562-2.318-7.562-2.318s-3.103-4.71-3.205-6.205c-.102-1.494-7.376 3.883-9.16 1.976-.77-.823.983-4.147-.87-6.095-1.008-1.06-4.942-2.524-4.942-2.524Z"
        fill="#fff"
        fillOpacity={0.199}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m254.912 16.684-1.435 1.469s9.505 1.027 10.579 2.009c2.015 1.84-.97 3.73.99 4.679 1.959.95 8.287 1.534 8.287 1.534s-5.083-1.837-6.543-2.805c-1.056-.7.913-3.62-1.006-4.932-1.918-1.312-10.872-1.954-10.872-1.954Z"
        fill="#000"
        fillOpacity={0.203}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252.936 38.706s2.028-.69 3.545-.004c1.517.684 12.833.494 12.833.494s-10.831-.696-11.961-1.395c-.818-.505-2.973-.841-3.388-1.106-1.485-.947-1.029 2.011-1.029 2.011Z"
        fill="#fff"
        fillOpacity={0.204}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M283.691 14.113s4.529 6.275 7.969 4.94c4.528-1.757 18.811 7.03 19.773 8.336 3.438 4.66-5.571 1.1-2.886 4.576 2.686 3.477 7.893 3.797 9.479 5.684 1.586 1.887.193 5.813.193 5.813s1.714-1.998-1.299-3.896-7.985-3.574-11.468-7.902c-3.483-4.328 6.236.61 2.812-3.985-.845-1.134-13.319-5.918-18.194-5.425-4.47.451-10.942-7.122-10.942-7.122l4.563-1.019Z"
        fill="#000"
        fillOpacity={0.203}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M274.376 105.538v5.709h6.59v-8.803s-10.69 1.006-16.4-1.071c3.903 2.633 9.81 4.165 9.81 4.165Z"
        fill="#000"
        fillOpacity={0.202}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m253.267 211.584-60.147 23.433s-11.803-3.154-16.506-1.647c-12.103 3.878-17.886 13.28-15.637 14.801 4.685 3.167 37.236-.215 37.236-.215l63.066-12.939-8.012-23.433Z"
        fill="#FF8780"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m160.978 248.17 12.796 2.792 86.013-12.82.035-7.386-98.844 17.414Z"
        fill="#404142"
        fillOpacity={0.16}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m245.878 266.682-117.955 37.987 163.254 9.057-.586-28.361-44.713-18.683Z"
        fill="#404142"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.591 111.769c0-.333.275-.595.608-.582 2.017.077 8.505.291 11.168-.025 3.172-.377 7.224-2.26 7.224-2.26v186.596c-18.321 0-57.806-9.735-71.444-20.735 3.387-1.068 24.774-8.081 24.774-8.081s-10.096-16.977-10.096-25.824c0-32.233 5.684-59.717 6.826-68.279 1.366-10.237 5.524-23.022 13.443-33.489 3.674-4.855 8.335-10.63 17.497-14.624v-12.697Z"
        fill="#F5C41A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M294.818 240.859s-22.875-.02-24.416-1.202c-1.325-1.017 14.958-6.105 14.958-6.105s-22.998-59.848-12.105-71.169c7.468-7.761 21.563 78.476 21.563 78.476Z"
        fill="#404142"
        fillOpacity={0.202}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m130.106 303.933 119.141-39.122 5.623 1.783-103.851 37.687-20.913-.348Z"
        fill="#404142"
        fillOpacity={0.294}
      />
      <path fill="#7FAEFF" d="M226.803 263.082h64.374v7.023h-64.374z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.267 261.22c-3.922-6.037 21.266-20.872 38.35-11.335 38.871-9.974 119.862-12.218 119.862-12.218s-39.932-76.737-7.409-86.496 53.325 102.45 35.269 110.049c-18.057 7.6-147.101 4.627-147.101 4.627h-8.609c-5.67 0-26.441 1.411-30.362-4.627Z"
        fill="#FF8780"
      />
      <path fill="#80AFFF" d="M226.803 266.594h7.023v37.454h-7.023z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M283.804 217.687c-17.168-38.74-16.412-60.912 2.265-66.517 17.538-5.262 28.417 23.245 34.883 53.386-10.619 9.147-23.115 14.746-37.148 13.131Z"
        fill="#F5C41A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M245.263 155.211c1.497-1.676 1.497-.598 2.132-.598 4.134-9.531 11.953-22.047 26.497-29.475v-13.892h-1.716a.585.585 0 0 0-.585.585v12.635c-11.319 4.157-22.55 18.487-26.328 30.745Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M272.019 111.431s14.183-.744 18.572-2.529v14.927l-14.544 8.737s-4.23-19.587-4.359-20.262c-.128-.675.331-.873.331-.873Z"
        fill="#000"
        fillOpacity={0.199}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.884 111.894a.585.585 0 0 1 .532-.742c2.093-.109 8.154-.439 10.95-.777 3.411-.413 7.225-1.473 7.225-1.473v13.584l-13.846 6.943-4.861-17.535Z"
        fill="#F5C41A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M290.591 119.82v2.668l-13.846 6.942-1.032-3.509 14.878-6.101ZM281.331 211.9s6.815-.716 11.969-1.463c5.155-.747 11.329-1.812 11.329-1.812l.64 2.297s-6.805 2.363-11.248 2.876c-4.443.513-11.417 1.1-11.417 1.1l-1.273-2.998Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271.591 111.745a.59.59 0 0 1 .585-.587c1.59-.023 6.059-.14 8.791-.762.039 2.012.173 16.926.173 16.926s-2.177 1.16-4.395 2.107c-10.469 2.318-20.193 15.307-24.776 28.135-7.372 20.637-8.062 82.31-8.062 82.31s-6.581.985-10.082.985c0-20.932 3.501-48.92 5.323-59.237 1.821-10.316 4.759-44.677 32.443-57.155v-12.722Z"
        fill="#000"
        fillOpacity={0.102}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m74.921 195.564 34.568 6.384s-2.586 22.041-1.505 29.314c1.386 9.326 32.209 11.65 57.644 11.65-78.372 0-97.084.294-98.332 0-1.957-.459-2.72-7.422-1.945-10.74 5.515-21.942 9.57-36.608 9.57-36.608Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m74.921 195.564 34.568 6.384s-.632 5.594-.876 8.105c-36.886-2.512-.448.067-36.91-2.571 1.14-4.308 3.218-11.918 3.218-11.918Z"
        fill="#000"
        fillOpacity={0.103}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.288 19.4c-.36-2.436 2.11-4.311 4.36-3.31l160.658 71.531a3.75 3.75 0 0 1 2.022 2.21l42.859 125.23c.759 2.217-1.104 4.449-3.421 4.099L36.262 192.674a7.496 7.496 0 0 1-6.297-6.316L5.288 19.401Z"
        fill="#2D426B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m206.388 189.348 8.799 25.712c.759 2.217-1.104 4.449-3.421 4.1L36.263 192.673a7.496 7.496 0 0 1-6.297-6.316l-3.239-21.911-1.017-6.882 180.678 31.784Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m63.554 111.805-.614-93.393 21.447 129.366-20.833-35.973Z"
        fill="url(#b)"
      />
      <g filter="url(#c)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.603 9.423c-.289-1.868 1.64-3.29 3.339-2.463l119.756 58.327a4.682 4.682 0 0 1 2.312 2.508l37.386 95.91c.672 1.724-.827 3.509-2.641 3.145L79.851 139.393a4.682 4.682 0 0 1-3.706-3.873L56.603 9.423Z"
          fill="#404142"
          fillOpacity={0.1}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.626 17.616c-.29-1.867 1.64-3.29 3.338-2.463L186.721 73.48a4.686 4.686 0 0 1 2.312 2.509l37.386 95.909c.672 1.724-.828 3.509-2.642 3.145L86.874 147.586a4.68 4.68 0 0 1-3.706-3.873L63.626 17.616Z"
        fill="#fff"
      />
      <path
        clipRule="evenodd"
        d="M110.417 67.552c-.27-.931.645-1.768 1.548-1.417l74.549 28.981a4.68 4.68 0 0 1 2.724 2.821l1.991 5.706c.323.924-.563 1.812-1.488 1.492l-73.777-25.553a4.683 4.683 0 0 1-2.965-3.12l-2.582-8.91ZM118.019 94.31a1.17 1.17 0 0 1 1.461-1.465l73.925 22.665a3.507 3.507 0 0 1 2.252 2.108l2.658 6.984a1.17 1.17 0 0 1-1.412 1.542l-73.831-20.902a3.512 3.512 0 0 1-2.399-2.342l-2.654-8.59ZM125.087 119.101a1.17 1.17 0 0 1 1.42-1.454l73.674 19.191a4.68 4.68 0 0 1 3.163 2.784l2.418 6.013a1.17 1.17 0 0 1-1.328 1.582l-73.135-15.44a4.682 4.682 0 0 1-3.535-3.296l-2.677-9.38Z"
        stroke="#A3A6A8"
        strokeWidth={0.798}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.514 60.516a.585.585 0 0 1 .755-.664l25.065 8.11c.387.124.681.442.777.837l.964 3.98a.585.585 0 0 1-.742.698l-24.547-7.609a2.341 2.341 0 0 1-1.609-1.805l-.663-3.547ZM93.804 90.697a.585.585 0 0 1 .724-.661l16.601 4.294a2.338 2.338 0 0 1 1.647 1.567l.935 2.985a.585.585 0 0 1-.693.744L96.07 95.607a2.341 2.341 0 0 1-1.77-1.897l-.496-3.013ZM93.607 115.181a.585.585 0 0 1 .7-.691l24.426 5.467a2.34 2.34 0 0 1 1.729 1.607l.913 3.025a.585.585 0 0 1-.68.742l-24.606-5.15a2.34 2.34 0 0 1-1.811-1.809l-.67-3.191Z"
        fill="#D8D8D8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M176.842 149.519a.585.585 0 0 1 .684-.717l28.81 5.843a2.342 2.342 0 0 1 1.701 1.406l2.797 6.827a.585.585 0 0 1-.651.797l-29.799-5.665a2.34 2.34 0 0 1-1.832-1.726l-1.71-6.765Z"
        fill="#4388FF"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={73.162}
        y1={-14.073}
        x2={32.074}
        y2={-13.907}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EEE" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <filter
        id="c"
        x={48.62}
        y={-1.235}
        width={178.893}
        height={176.087}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={3.977}
          result="effect1_foregroundBlur_9689_215705"
        />
      </filter>
    </defs>
  </svg>
)

export const WelcomeCoin0 = (props: any) => (
  <svg width={39} height={39} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m13.692 18.02 6.502-8.792 5.212 9.63-6.09 2.782-5.624-3.62Zm3.487-.436 2.687-3.703 2.228 4.125-2.582.778-2.333-1.2ZM13.026 19.7l6.145 3.895 6.628-2.98-7.057 8.814-5.716-9.729Zm5.386 14.518c8.263.592 15.442-5.626 16.034-13.89.592-8.263-5.627-15.44-13.89-16.033-8.263-.592-15.442 5.627-16.034 13.89-.591 8.263 5.627 15.441 13.89 16.033Z"
      fill="#F0C74A"
    />
  </svg>
)

export const WelcomeCoin1 = (props: any) => (
  <svg width={27} height={26} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.213 13.557c-.394 5.509-5.18 9.655-10.689 9.26-5.509-.395-9.654-5.18-9.26-10.69.395-5.508 5.18-9.654 10.69-9.259 5.508.395 9.654 5.18 9.26 10.689Zm-3.976-3.273-3.172-.227a1.067 1.067 0 0 0-1.133.982l-.026.359-2.813-.202.026-.359a3.884 3.884 0 0 1 4.148-3.592l3.171.227-.201 2.812Zm-7.345 3.725.202-2.813-1.058-.075a3.884 3.884 0 0 0-4.147 3.592 3.884 3.884 0 0 0 3.593 4.148 3.884 3.884 0 0 0 4.147-3.593l.076-1.057 2.813.201.201-2.813-2.813-.201-.201 2.813-2.813-.202Zm0 0-.076 1.057a1.067 1.067 0 0 1-1.133.982 1.067 1.067 0 0 1-.981-1.133 1.067 1.067 0 0 1 1.133-.981l1.057.075Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeCoin2 = (props: any) => (
  <svg width={31} height={31} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.718 26.701c6.427.46 12.01-4.376 12.47-10.803.461-6.427-4.376-12.01-10.803-12.47C9.96 2.966 4.375 7.803 3.915 14.23c-.46 6.427 4.376 12.01 10.803 12.471Zm4.108-5.033-.097.032-.112.085-.272-.02c-.303-.021-.342-.046-.41-.088l-.001-.001c-.07-.044-3.007-2.057-3.054-2.099a1.054 1.054 0 0 1-.206-.234.95.95 0 0 1-.12-.278l-.011-.057c-.016-.095-.01-.194.037-.837l.05-.705 1.513-.738-.05.7c-.047.728-.047.729-.017.848l.005.019c.052.191.16.363.31.495l.853.61.314.228c.333.241.527.382.562.385a1 1 0 0 0 .803.057c.132-.045 1.807-.881 1.866-.916a.946.946 0 0 0 .414-.58l.16-2.236a.956.956 0 0 0-.311-.622c-.046-.058-1.643-1.183-1.707-1.22a.45.45 0 0 0-.108-.053.979.979 0 0 0-.739-.025l-1.157.593c-1.07.544-1.242.626-1.87.916l-.242.11c-.479.221-.809.373-1.623.79l-1.155.57a1.013 1.013 0 0 1-.848-.06 615.602 615.602 0 0 1-3.092-2.101 1.21 1.21 0 0 1-.242-.287.866.866 0 0 1-.114-.349l.144-2.006.143-2.007a.908.908 0 0 1 .425-.563c.03-.02.792-.394 1.698-.835 1.224-.593 1.668-.803 1.73-.826l.086-.027.605.043.112.063c.139.087 3.029 2.053 3.082 2.095a1.032 1.032 0 0 1 .314.505c.035.14.035.14-.017.874l-.05.683-.756.369-.767.368.05-.689.054-.765a.92.92 0 0 0-.083-.248.893.893 0 0 0-.26-.326c-.117-.08-1.658-1.13-1.711-1.162a.997.997 0 0 0-.82-.058c-.031.02-.61.307-1.1.551-.352.175-.657.327-.686.343a.956.956 0 0 0-.243.202c-.07.085-.127.18-.17.28-.101.415-.145.843-.13 1.27-.047.363-.073.728-.08 1.094.02.127.062.249.125.36.058.092.13.175.211.247.084.072 1.672 1.169 1.733 1.173.123.064.26.102.398.111.14.012.282-.01.412-.064.04-.008.575-.255 1.154-.554l1.87-.91 1.894-.926c.26-.126.473-.231.643-.315.339-.168.506-.25.54-.248a.973.973 0 0 1 .792.056l2.843 1.924c.147.088.28.195.395.32.123.148.197.33.214.52l-.28 3.91a.84.84 0 0 1-.255.438.922.922 0 0 1-.245.164l-3.343 1.634Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeCoin3 = (props: any) => (
  <svg width={43} height={43} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.304 37.913c8.951.642 16.728-6.095 17.37-15.047.64-8.952-6.096-16.728-15.048-17.37-8.952-.64-16.728 6.096-17.37 15.048-.64 8.951 6.096 16.728 15.048 17.37ZM15.41 14.12a.671.671 0 0 1 .462-.146l15.522 1.112c.283.02.402.358.187.536l-3.276 2.714a.653.653 0 0 1-.463.146l-15.52-1.112c-.285-.02-.403-.358-.189-.536l3.277-2.714Zm-.785 10.956a.653.653 0 0 1 .462-.146L30.61 26.04c.283.02.402.358.188.535l-3.277 2.715a.653.653 0 0 1-.462.146l-15.522-1.112c-.283-.02-.402-.358-.188-.536l3.277-2.715Zm13.088-4.783c.17.012.328.09.437.21l2.856 3.154c.186.206.021.524-.262.504l-15.522-1.112a.653.653 0 0 1-.437-.21l-2.856-3.155c-.187-.206-.021-.523.262-.503l15.522 1.112Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeCoin4 = (props: any) => (
  <svg width={27} height={27} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.742 14.53c-.394 5.508-5.18 9.654-10.689 9.26-5.508-.395-9.654-5.18-9.26-10.69.395-5.508 5.18-9.654 10.69-9.26 5.508.395 9.654 5.18 9.26 10.69Zm-9.605-6.394a.393.393 0 0 0 .436-.336.39.39 0 0 0-.335-.436.39.39 0 0 0-.436.332.395.395 0 0 0 .335.44Zm3.612.31a.303.303 0 0 1-.427.06.314.314 0 0 1-.059-.43.306.306 0 0 1 .427-.056.303.303 0 0 1 .06.427Zm-6.8-.366a.308.308 0 0 0 .163-.4.308.308 0 0 0-.4-.164.304.304 0 0 0-.163.396.302.302 0 0 0 .4.168Zm.484 6.517a.943.943 0 0 1 .187-1.877.938.938 0 0 1 .875 1.006.938.938 0 0 1-1.006.875l-.056-.004Zm-4.647-1.284a.305.305 0 1 1 .605.077.305.305 0 0 1-.605-.077Zm5.25-4.115a.471.471 0 0 1-.867.36.471.471 0 0 1 .868-.36Zm-3.545 1.527a.39.39 0 0 0 .545-.073.39.39 0 0 0-.074-.544.39.39 0 0 0-.544.073.386.386 0 0 0 .073.545Zm-.118 2.69a.471.471 0 1 1 .934.12.471.471 0 0 1-.934-.12Zm-.216 2.71a.39.39 0 1 0 .301.718.39.39 0 0 0-.301-.718Zm2.895-4.1a.55.55 0 0 1-.775.105.55.55 0 0 1-.105-.775.55.55 0 0 1 .774-.106.55.55 0 0 1 .106.775Zm5.19-1.93a.474.474 0 0 0 .662-.088.474.474 0 0 0-.087-.661.474.474 0 0 0-.662.087.466.466 0 0 0 .088.661Zm-.139 2.939a.94.94 0 0 0-1.054.815.94.94 0 0 0 .816 1.054l.052.004a.942.942 0 0 0 .186-1.873Zm-3.375-.276a.945.945 0 0 1-.296-1.814.941.941 0 0 1 1.302.94.942.942 0 0 1-1.005.874Zm6.651-1.252a.389.389 0 1 0-.513-.21.395.395 0 0 0 .513.21Zm-2.703.85a.554.554 0 1 1 1.023-.424.554.554 0 0 1-1.023.424Zm-2.098-2.269a.55.55 0 0 1-.618.48.552.552 0 0 1-.48-.618.55.55 0 0 1 .618-.48.55.55 0 0 1 .48.618Zm-4.017 5.91a.554.554 0 1 0-.425-1.022.554.554 0 0 0 .425 1.023Zm3.877-3.277a.94.94 0 0 1 .637-1.688.94.94 0 1 1-.637 1.687Zm1.174 2.73a.94.94 0 0 0-1.232-.508.941.941 0 0 0-.508 1.233.941.941 0 0 0 1.233.507.938.938 0 0 0 .51-1.224v-.003s0-.003-.003-.005Zm.872.156a.55.55 0 0 1 .775-.105.551.551 0 0 1 .105.774.55.55 0 0 1-.774.106.55.55 0 0 1-.106-.775Zm2.678-1.388a.47.47 0 0 0-.407-.527.47.47 0 0 0-.527.408.469.469 0 0 0 .407.527.474.474 0 0 0 .527-.408Zm.983.022a.302.302 0 0 1 .341-.264.305.305 0 1 1-.34.264Zm-1.1 2.665a.39.39 0 0 0-.544.073.39.39 0 0 0 .073.544.39.39 0 0 0 .544-.073.386.386 0 0 0-.073-.544Zm-9.262 2.274a.306.306 0 0 1 .427-.055.3.3 0 0 1 .056.427.306.306 0 0 1-.427.055.306.306 0 0 1-.056-.427Zm6.804.372a.308.308 0 0 0-.163.4.308.308 0 0 0 .4.163.304.304 0 0 0 .163-.396.302.302 0 0 0-.4-.167Zm-3.489-4.644a.945.945 0 0 1 .179 1.323.929.929 0 0 1-.82.367.942.942 0 0 1-.681-1.512.945.945 0 0 1 1.322-.178Zm-1.805 2.629a.474.474 0 0 0-.66.087.474.474 0 0 0 .086.662.474.474 0 0 0 .662-.088.467.467 0 0 0-.088-.661Zm1.629 2.291a.393.393 0 0 1 .436-.336c.21.03.362.225.335.44a.39.39 0 0 1-.435.332.39.39 0 0 1-.336-.436Zm.614-2.767a.55.55 0 0 0-.619.48.55.55 0 0 0 .48.618.552.552 0 1 0 .139-1.098Zm1.967 1.376a.472.472 0 1 1 .868-.368.472.472 0 0 1-.868.368Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeCoin5 = (props: any) => (
  <svg width={27} height={27} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m17.112 13.548-3.296-3.804-3.804 3.296 3.296 3.803 3.804-3.295Zm-3.126-6.173L7.643 12.87l5.495 6.343 6.344-5.495-5.496-6.343Zm-10.4 5.203c.395-5.51 5.181-9.655 10.69-9.26 5.51.394 9.655 5.18 9.26 10.689-.394 5.509-5.18 9.655-10.689 9.26-5.509-.394-9.655-5.18-9.26-10.69Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeCoin6 = (props: any) => (
  <svg width={43} height={44} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m17.534 13.602-1.405-.1-.198 2.773 1.404.1-.293 4.092-.437 5.888-1.444-.103-.2 2.792 1.444.103-.148 2.073 1.884.135.149-2.073 1.41.101-.149 2.073 1.827.131.149-2.073.801.057c1.975.142 5.05-1.244 5.27-4.31.133-1.853-.866-3.057-2.114-3.752.851-.705 1.489-1.721 1.586-3.073.222-3.097-1.734-4.275-3.7-4.415l-.721-.052.148-2.065-1.85-.132-.149 2.064-1.402-.1.148-2.065-1.862-.133-.148 2.064Zm4.727 3.126-2.162-.154-.258 3.604 2.161.154c1.465.105 2.132-.302 2.232-1.703.1-1.4-.381-1.787-1.973-1.9Zm.398 6.442-3.04-.217-.257 3.6 3.039.218c1.052.075 2.296-.103 2.395-1.485.12-1.668-.854-2.024-2.137-2.116Zm-2.28 15.152c9.182.658 17.158-6.252 17.816-15.433.657-9.18-6.252-17.157-15.433-17.815-9.182-.657-17.158 6.252-17.816 15.433-.657 9.182 6.252 17.158 15.434 17.815Z"
      fill="#F0C74A"
    />
  </svg>
)
export const WelcomeRow0 = (props: any) => (
  <svg width={100} height={21} fill="none" {...props}>
    <rect y={0.652} width={100} height={20} rx={5} fill="#F4D57D" />
  </svg>
)
export const WelcomeRow1 = (props: any) => (
  <svg width={73} height={21} fill="none" {...props}>
    <rect y={0.652} width={73} height={20} rx={5} fill="#F9E6B0" />
  </svg>
)
export const WelcomeRow2 = (props: any) => (
  <svg width={89} height={21} fill="none" {...props}>
    <rect y={0.652} width={89} height={20} rx={5} fill="#F4D57D" />
  </svg>
)
export const WelcomeCol0 = (props: any) => (
  <svg width={20} height={32} fill="none" {...props}>
    <rect
      y={31.652}
      width={31}
      height={20}
      rx={5}
      transform="rotate(-90 0 31.652)"
      fill="#85AFF9"
    />
  </svg>
)
export const WelcomeCol1 = (props: any) => (
  <svg width={20} height={46} fill="none" {...props}>
    <rect
      y={45.652}
      width={45}
      height={20}
      rx={5}
      transform="rotate(-90 0 45.652)"
      fill="#7EAEFF"
    />
  </svg>
)
export const WelcomeCol2 = (props: any) => (
  <svg width={20} height={67} fill="none" {...props}>
    <rect
      y={66.652}
      width={66}
      height={20}
      rx={5}
      transform="rotate(-90 0 66.652)"
      fill="#7CABFD"
    />
  </svg>
)
export const WelcomeCol3 = (props: any) => (
  <svg width={20} height={90} fill="none" {...props}>
    <rect
      y={89.652}
      width={89}
      height={20}
      rx={5}
      transform="rotate(-90 0 89.652)"
      fill="#75A8FF"
    />
  </svg>
)
export const WelcomeCol4 = (props: any) => (
  <svg width={20} height={103} fill="none" {...props}>
    <rect
      y={102.652}
      width={102}
      height={20}
      rx={5}
      transform="rotate(-90 0 102.652)"
      fill="#5C98FF"
    />
  </svg>
)
export const WelcomeCol5 = (props: any) => (
  <svg width={20} height={121} fill="none" {...props}>
    <rect
      y={120.652}
      width={120}
      height={20}
      rx={5}
      transform="rotate(-90 0 120.652)"
      fill="#4388FF"
    />
  </svg>
)
export const WelcomeCheck = (props: any) => (
  <svg width={24} height={25} viewBox="0 0 24 25" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.939 14.079a.5.5 0 0 1-.706.001L8.27 12.13a1 1 0 0 0-1.412.002l-.049.05a1 1 0 0 0 .002 1.415l3.067 3.056a1 1 0 0 0 1.413-.002l5.896-5.895a1 1 0 0 0 0-1.414l-.048-.049a1 1 0 0 0-1.415 0l-4.786 4.786ZM22 12.652c0 5.523-4.477 10-10 10s-10-4.477-10-10c0-5.522 4.477-10 10-10s10 4.478 10 10Z"
      fill="#fff"
    />
  </svg>
)

export const WelcomeR1 = (props: any) => (
  <SvgIcon width={453} height={256} viewBox="0 0 453 256" {...props}>
    <g filter="url(#a2)">
      <path
        stroke="#646464"
        stroke-width="0px"
        stroke-dasharray="2,2"
        stroke-linejoin="round"
        d="M12.932 255.612c-7.12 0-12.891-5.779-12.891-12.908V13.6C.041 6.472 5.812.693 12.932.693h426.829c7.12 0 12.891 5.779 12.891 12.907v229.104c0 7.129-5.771 12.908-12.891 12.908H12.932Z"
        fill="url(#b2)"
      />
    </g>
    <defs>
      <radialGradient
        id="b2"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-28.545 476.908 65.97) scale(507.9 285.892)"
      >
        <stop stopColor="#fff" stopOpacity={0.55} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <filter
        id="a2"
        x={0}
        y={0}
        width={453}
        height={256}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={6} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_8051_175849"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_8051_175849"
          result="shape"
        />
      </filter>
    </defs>
  </SvgIcon>
)

export const WelcomeR0 = (props: any) => (
  <SvgIcon width={453} height={256} viewBox="0 0 453 256" {...props}>
    <filter id="noiseFilter">
      <feTurbulence
        type="fractalNoise"
        baseFrequency="1"
        numOctaves="1"
        stitchTiles="stitch"
      />
    </filter>

    <rect width="100%" height="100%" filter="url(#noiseFilter)" />
  </SvgIcon>
)

export const WelcomeE4 = (props: any) => (
  <svg width={491} height={25} fill="none" {...props}>
    <path
      d="M491 12.652c0 6.628-109.914 12-245.5 12S0 19.28 0 12.652c0-6.627 109.914-12 245.5-12s245.5 5.373 245.5 12Z"
      fill="url(#a3)"
      style={{
        mixBlendMode: 'darken',
      }}
      opacity={0.1}
    />
    <defs>
      <linearGradient
        id="a3"
        x1={0}
        y1={12.652}
        x2={491}
        y2={12.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F581FF" />
        <stop offset={1} stopColor="#FFB388" />
      </linearGradient>
    </defs>
  </svg>
)

export const WelcomeE3 = (props: any) => (
  <svg
    width={289}
    height={286}
    viewBox="0 0 289 286"
    fill="none"
    {...props}
    transform-origin="0% 100%"
  >
    <path
      d="M264.366 119.068c13.152 65.257-29.917 128.987-96.197 142.345-66.28 13.358-130.672-28.714-143.824-93.97-13.152-65.257 29.917-128.987 96.197-142.345 66.28-13.358 130.672 28.714 143.824 93.97Z"
      fill="url(#a4)"
    />
    <path
      d="M195.393 99.024c2.841 14.095-6.462 27.86-20.778 30.745-14.316 2.886-28.224-6.202-31.065-20.297-2.841-14.095 6.462-27.86 20.778-30.745 14.316-2.885 28.224 6.202 31.065 20.297Z"
      fill="#FFADF3"
    />
    <defs>
      <linearGradient
        id="a4"
        x1={24.345}
        y1={167.443}
        x2={264.366}
        y2={119.068}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F581FF" />
        <stop offset={1} stopColor="#FFB388" />
      </linearGradient>
    </defs>
  </svg>
)

export const WelcomeE2 = (props: any) => (
  <SvgIcon width={384} height={384} viewBox="0 0 384 384" {...props}>
    <path
      d="M379.241 153.938c20.874 103.574-46.167 204.46-149.741 225.334-103.574 20.875-204.46-46.166-225.334-149.74C-16.71 125.958 50.332 25.072 153.907 4.198c103.574-20.875 204.459 46.166 225.334 149.74Z"
      fill="url(#a5)"
    />
    <defs>
      <linearGradient
        id="a5"
        x1={4.166}
        y1={229.532}
        x2={379.241}
        y2={153.938}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F581FF" />
        <stop offset={1} stopColor="#FFB388" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

export const WelcomeE1 = (props: any) => (
  <SvgIcon width={448} height={448} viewBox="0 0 448 448" {...props}>
    <path
      opacity={0.1}
      d="M442.824 179.574c24.39 121.017-53.941 238.892-174.958 263.282-121.017 24.39-238.892-53.942-263.282-174.958C-19.806 146.881 58.525 29.005 179.542 4.615c121.017-24.39 238.892 53.942 263.282 174.959Z"
      fill="url(#a6)"
    />
    <defs>
      <linearGradient
        id="a6"
        x1={4.584}
        y1={267.898}
        x2={442.824}
        y2={179.574}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F581FF" />
        <stop offset={1} stopColor="#FFB388" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

export const WelcomeE0 = (props: any) => (
  <SvgIcon width={524} height={524} viewBox="0 0 524 524" {...props}>
    <path
      opacity={0.1}
      d="M522.575 280.463c-10.32 144.054-135.465 252.466-279.518 242.146C99.004 512.289-9.408 387.145.912 243.091 11.232 99.038 136.376-9.374 280.429.946c144.053 10.32 252.466 135.464 242.146 279.517Z"
      fill="url(#a7)"
    />
    <defs>
      <linearGradient
        id="a7"
        x1={0.912}
        y1={243.091}
        x2={522.575}
        y2={280.463}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F581FF" />
        <stop offset={1} stopColor="#FFB388" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

export const StickIcon = (props: any) => (
  <SvgIcon width={20} height={20} fill="none" {...props}>
    <path
      d="M.318 8.49c-.27.09-.324.589-.318.826.68 1.21 2.526 4.308 4.472 7.032 3.031 3.105 5.389-.112 5.763-.524.374-.411 4.565-7.334 6.1-10.44 1.225-2.482 1.908-3.892 1.571-5.35-.162-.026-.763-.06-1.87 0-1.108.059-1.884 1.321-2.134 1.945-1.771 3.368-5.598 10.373-5.987 11.3-.39.929-.649.7-.823.488-.936-1.61-2.89-4.986-3.219-5.615-.329-.628-1.185-.66-1.571-.598-.55.275-1.714.846-1.984.936Z"
      fill="#27AE60"
    />
  </SvgIcon>
)

export const FacebookIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <g clipPath="url(#aFacebookIcon)">
      <path
        stroke="#C4C4C4"
        d="M20 39.5C9.23 39.5.5 30.77.5 20S9.23.5 20 .5 39.5 9.23 39.5 20 30.77 39.5 20 39.5Z"
      />
      <path
        fill="#717275"
        fillRule="evenodd"
        d="m23.504 13.321 1.882-.001v-3.18c-.326-.044-1.444-.14-2.744-.14-2.713 0-4.572 1.656-4.572 4.7v2.621H15v3.556h3.07V30h3.671v-9.122h3.063l.459-3.557H21.74v-2.27c0-1.028.287-1.73 1.763-1.73Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="aFacebookIcon">
        <path fill="#fff" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const GithubIcon = (props: any) => (
  <SvgIcon width={26} height={26} fill="none" viewBox="0 0 26 26" {...props}>
    <path
      d="M12.994.69C6.01.686.354 6.34.354 13.317c0 5.518 3.538 10.208 8.466 11.931.664.167.562-.305.562-.627v-2.188c-3.832.449-3.987-2.087-4.244-2.51-.52-.888-1.748-1.113-1.381-1.537.872-.45 1.762.113 2.793 1.635.745 1.104 2.2.918 2.936.734a3.562 3.562 0 0 1 .98-1.717c-3.97-.711-5.625-3.134-5.625-6.015 0-1.397.46-2.682 1.364-3.719-.576-1.708.054-3.171.138-3.388C7.984 5.77 9.69 7.09 9.823 7.196c.931-.252 1.996-.384 3.188-.384 1.197 0 2.264.138 3.205.392.319-.243 1.9-1.378 3.425-1.24.082.218.698 1.647.156 3.333.915 1.039 1.38 2.335 1.38 3.736 0 2.886-1.666 5.312-5.647 6.012a3.6 3.6 0 0 1 1.076 2.57v3.177c.022.254 0 .505.423.505 5.001-1.686 8.602-6.41 8.602-11.976C25.63 6.34 19.97.689 12.994.689Z"
      fill="#717275"
    />
  </SvgIcon>
)
export const LinkedInIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <path
      stroke="#C4C4C4"
      d="M20 39.5C9.23 39.5.5 30.77.5 20S9.23.5 20 .5 39.5 9.23 39.5 20 30.77 39.5 20 39.5Z"
    />
    <path
      fill="#717275"
      d="M14.5 30h-4.25V16.625h4.25V30Zm-2.125-15.25C11 14.75 10 13.75 10 12.375S11.125 10 12.375 10c1.375 0 2.375 1 2.375 2.375s-1 2.375-2.375 2.375ZM30 30h-4.25v-7.25c0-2.125-.875-2.75-2.125-2.75s-2.5 1-2.5 2.875V30h-4.25V16.625h4V18.5c.375-.875 1.875-2.25 4-2.25 2.375 0 4.875 1.375 4.875 5.5V30H30Z"
    />
  </svg>
)
export const MediumIcon = (props: any) => (
  <SvgIcon width={18} height={18} fill="none" {...props}>
    <path
      d="M17 0H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Zm-2.046 4.265-.966.925a.28.28 0 0 0-.106.271v6.801a.28.28 0 0 0 .106.271l.942.926v.204h-4.741v-.204l.977-.948c.097-.096.097-.125.097-.271V6.742l-2.716 6.896h-.368L5.018 6.742v4.622a.644.644 0 0 0 .176.531l1.271 1.541v.203H2.861v-.203l1.271-1.541a.618.618 0 0 0 .164-.531V6.02a.468.468 0 0 0-.152-.395l-1.13-1.36v-.203H6.52l2.71 5.943 2.382-5.943h3.343v.203h-.001Z"
      fill="#717275"
    />
  </SvgIcon>
)
export const TelegramIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <path
      stroke="#C4C4C4"
      d="M20 39.5C9.23 39.5.5 30.77.5 20S9.23.5 20 .5 39.5 9.23 39.5 20 30.77 39.5 20 39.5Z"
    />
    <path
      fill="#717275"
      d="M10.125 19.635c5.369-2.339 8.949-3.88 10.74-4.626 5.114-2.127 6.177-2.497 6.87-2.509.152-.002.493.035.713.214.186.152.238.356.262.5.025.142.055.469.031.724-.277 2.912-1.476 9.979-2.086 13.24-.259 1.38-.767 1.843-1.259 1.889-1.07.098-1.881-.707-2.917-1.386-1.621-1.063-2.537-1.724-4.11-2.761-1.819-1.198-.64-1.857.396-2.933.272-.282 4.984-4.568 5.075-4.956.011-.05.022-.23-.086-.326-.108-.096-.266-.063-.381-.037-.163.037-2.752 1.748-7.768 5.134-.735.505-1.4.751-1.997.738-.658-.014-1.923-.372-2.863-.677-1.153-.375-2.07-.573-1.99-1.21.041-.332.498-.67 1.37-1.018Z"
    />
  </svg>
)
export const TwitterIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <rect width={39} height={39} x={0.5} y={0.5} stroke="#C4C4C4" rx={19.5} />
    <path
      fill="#717275"
      d="M26.326 9.904H29.7l-7.37 8.423L31 29.79h-6.789l-5.317-6.952-6.084 6.952H9.434l7.883-9.01L9 9.904h6.961l4.806 6.354 5.56-6.354ZM25.142 27.77h1.87L14.945 11.817H12.94L25.142 27.77Z"
    />
  </svg>
)
export const YoutubeIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <path
      stroke="#C4C4C4"
      d="M20 39.5C9.23 39.5.5 30.77.5 20S9.23.5 20 .5 39.5 9.23 39.5 20 30.77 39.5 20 39.5Z"
    />
    <path
      fill="#717275"
      d="M29.5 15.125a2.476 2.476 0 0 0-1.75-1.75C26.25 13 19.875 13 19.875 13s-6.25 0-7.875.375c-.875.25-1.5.875-1.75 1.75C10 16.75 10 20 10 20s0 3.25.375 4.875c.25.875.875 1.5 1.75 1.75C13.625 27 20 27 20 27s6.25 0 7.875-.375c.875-.25 1.5-.875 1.75-1.75C30 23.25 30 20 30 20s0-3.25-.5-4.875ZM18 23v-6l5.25 3L18 23Z"
    />
  </svg>
)

export const PublicLink = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <rect width={40} height={40} fill="#F0F1F3" rx={20} />
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M20 30c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Zm-.844-18.313v7.454h-2.89c.132-3.685 1.455-6.618 2.89-7.454Zm9.163 7.454h-2.895c-.112-3.298-1.106-5.762-1.773-6.851 3.664 1.948 4.523 5.258 4.668 6.85Zm-13.753 0H11.68c.182-1.818 1.136-5.03 4.647-6.84-.76 1.336-1.61 3.426-1.762 6.84Zm0 1.72H11.68c.12 1.78 1.185 5.05 4.647 6.836-.357-.567-1.63-3.052-1.762-6.835Zm10.858 0h2.895c-.168 2.008-1.407 5.2-4.668 6.836.777-1.3 1.588-3.486 1.773-6.835Zm-6.268 0v7.452c-1.355-.715-2.766-3.7-2.89-7.451h2.89Zm1.682-9.174v7.454h2.902c-.172-3.697-1.488-6.682-2.902-7.454Zm0 9.175v7.451c1.356-.754 2.734-3.635 2.902-7.451h-2.902Z"
      clipRule="evenodd"
    />
  </svg>
)

export const RestrictedLink = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <rect width={40} height={40} fill="#F0F1F3" rx={20} />
    <path
      fill="#717275"
      fillRule="evenodd"
      d="M25 18h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1h2v-3a5 5 0 0 1 10 0v3Zm-8.2 0h6.4v-2c0-2.77-1.43-4-3.2-4-1.77 0-3.2 1.23-3.2 4v2Zm-3 1.8v8.4h12.4v-8.4H13.8Z"
      clipRule="evenodd"
    />
  </svg>
)

export const GlobalIconGrey = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.66 4.299c.123.209.24.426.348.648.805 1.65 1.317 3.815 1.418 6.187h2.89C20.023 8.121 18.203 5.57 15.66 4.3Zm4.657 8.562h-2.891c-.1 2.372-.613 4.537-1.418 6.187-.109.223-.225.44-.348.649 2.542-1.27 4.362-3.823 4.657-6.836ZM8.34 19.697a9.375 9.375 0 0 1-.348-.649c-.806-1.65-1.318-3.815-1.419-6.187h-2.89c.294 3.013 2.114 5.566 4.657 6.836Zm-4.657-8.563h2.89c.1-2.372.613-4.536 1.419-6.187.108-.222.224-.44.348-.648-2.543 1.27-4.363 3.822-4.657 6.835ZM9.5 5.72c-.673 1.38-1.139 3.27-1.239 5.414h2.895v-7.45c-.558.322-1.138.975-1.656 2.036Zm4.998 0c.674 1.38 1.14 3.27 1.239 5.414h-2.895v-7.45c.558.322 1.139.975 1.656 2.036Zm-1.656 7.141h2.895c-.1 2.144-.565 4.035-1.239 5.415-.518 1.06-1.098 1.713-1.656 2.036v-7.45Zm-3.342 5.415c.518 1.06 1.098 1.713 1.656 2.036v-7.45H8.262c.1 2.143.566 4.034 1.239 5.414ZM2 12C2 6.477 6.477 2 12 2c5.522 0 10 4.477 10 10s-4.478 10-10 10C6.476 22 2 17.523 2 12Z"
      fill="#717275"
    />
  </svg>
)

export const DownArrowIconGrey = (props: any) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      d="M3.112 6.894a.375.375 0 0 0 0 .53l5.623 5.624a.375.375 0 0 0 .53 0l5.623-5.623a.375.375 0 0 0 0-.53l-.805-.806a.375.375 0 0 0-.53 0l-4.288 4.283a.375.375 0 0 1-.53 0L4.449 6.087a.375.375 0 0 0-.53 0l-.807.807Z"
      fill="#717275"
    />
  </svg>
)
export const DownArrowIcon = (props: any) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      d="M3.112 6.894a.375.375 0 0 0 0 .53l5.623 5.624a.375.375 0 0 0 .53 0l5.623-5.623a.375.375 0 0 0 0-.53l-.805-.806a.375.375 0 0 0-.53 0l-4.288 4.283a.375.375 0 0 1-.53 0L4.449 6.087a.375.375 0 0 0-.53 0l-.807.807Z"
      fill="#fff"
    />
  </svg>
)

export const DownArrowIconBlue = (props: any) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      d="M3.112 6.894a.375.375 0 0 0 0 .53l5.623 5.624a.375.375 0 0 0 .53 0l5.623-5.623a.375.375 0 0 0 0-.53l-.805-.806a.375.375 0 0 0-.53 0l-4.288 4.283a.375.375 0 0 1-.53 0L4.449 6.087a.375.375 0 0 0-.53 0l-.807.807Z"
      fill="#4388FF"
    />
  </svg>
)

export const DownArrowIcon200 = (props: any) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      d="M3.112 6.894a.375.375 0 0 0 0 .53l5.623 5.624a.375.375 0 0 0 .53 0l5.623-5.623a.375.375 0 0 0 0-.53l-.805-.806a.375.375 0 0 0-.53 0l-4.288 4.283a.375.375 0 0 1-.53 0L4.449 6.087a.375.375 0 0 0-.53 0l-.807.807Z"
      fill="#9EC1FF"
    />
  </svg>
)
export const GlobalIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.66 4.299c.123.209.24.426.348.648.805 1.65 1.317 3.815 1.418 6.187h2.89C20.023 8.121 18.203 5.57 15.66 4.3Zm4.657 8.562h-2.891c-.1 2.372-.613 4.537-1.418 6.187-.109.223-.225.44-.348.649 2.542-1.27 4.362-3.823 4.657-6.836ZM8.34 19.697a9.375 9.375 0 0 1-.348-.649c-.806-1.65-1.318-3.815-1.419-6.187h-2.89c.294 3.013 2.114 5.566 4.657 6.836Zm-4.657-8.563h2.89c.1-2.372.613-4.536 1.419-6.187.108-.222.224-.44.348-.648-2.543 1.27-4.363 3.822-4.657 6.835ZM9.5 5.72c-.673 1.38-1.139 3.27-1.239 5.414h2.895v-7.45c-.558.322-1.138.975-1.656 2.036Zm4.998 0c.674 1.38 1.14 3.27 1.239 5.414h-2.895v-7.45c.558.322 1.139.975 1.656 2.036Zm-1.656 7.141h2.895c-.1 2.144-.565 4.035-1.239 5.415-.518 1.06-1.098 1.713-1.656 2.036v-7.45Zm-3.342 5.415c.518 1.06 1.098 1.713 1.656 2.036v-7.45H8.262c.1 2.143.566 4.034 1.239 5.414ZM2 12C2 6.477 6.477 2 12 2c5.522 0 10 4.477 10 10s-4.478 10-10 10C6.476 22 2 17.523 2 12Z"
      fill="#fff"
    />
  </svg>
)
// blockpass logo big
export const BlockpassLogoBig = (props: any) => (
  <SvgIcon width={80} height={80} viewBox="0 0 80 80" fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M18.461 10.91H0v18.46H18.46V10.91Zm0 20.512H0v18.461H18.46V31.422Zm2.052 0h18.461v18.461H20.513V31.422Zm38.974 0H41.026v18.461h18.461V31.422ZM41.026 51.934h18.461v18.462H41.026V51.934Zm38.973-20.512H61.538v18.461h18.461V31.422Z"
      clipRule="evenodd"
    />
  </SvgIcon>
)

// blockpass logo
export const BlockpassLogo = (props: any) => (
  <SvgIcon width={48} height={48} fill="none" viewBox="0 0 48 48" {...props}>
    <path
      d="M0 8a8 8 0 0 1 8-8h28a8 8 0 0 1 8 8v28a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
      fill="#4388FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 8H3v9h9V8Zm0 10H3v9h9v-9Zm1 0h9v9h-9v-9Zm19 0h-9v9h9v-9Zm-9 10h9v9h-9v-9Zm19-10h-9v9h9v-9Z"
      fill="#fff"
    />
  </SvgIcon>
)
// blockpass logo login
export const BlockpassLogoLogin = (props: any) => (
  <svg width={25} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.038 3.273H.5V8.81h5.538V3.273Zm0 6.154H.5v5.538h5.538V9.427Zm.616 0h5.538v5.538H6.654V9.427Zm11.692 0h-5.538v5.538h5.538V9.427Zm-5.538 6.153h5.538v5.539h-5.538V15.58ZM24.5 9.427h-5.538v5.538H24.5V9.427Z"
      clipRule="evenodd"
    />
  </svg>
)

// menu logo
export const MenuLogo = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#fff"
      d="M4.105 11.66a.5.5 0 0 1 .5-.5h14.789a.5.5 0 0 1 .5.5v.68a.5.5 0 0 1-.5.5H4.605a.5.5 0 0 1-.5-.5v-.68ZM4.105 5.973a.5.5 0 0 1 .5-.5h14.789a.5.5 0 0 1 .5.5v.68a.5.5 0 0 1-.5.5H4.605a.5.5 0 0 1-.5-.5v-.68ZM4.105 17.348a.5.5 0 0 1 .5-.5h14.789a.5.5 0 0 1 .5.5v.68a.5.5 0 0 1-.5.5H4.605a.5.5 0 0 1-.5-.5v-.68Z"
    />
  </svg>
)

// stupid share classNamme
export const SettingIcon = (props: any) => (
  <SvgIcon
    class="MuiSvgIcon-root"
    focusable="false"
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#4388FF"
    {...props}
  >
    <path d="m14.586 8.625 1.633.395A4.384 4.384 0 0 0 16.34 8a4.357 4.357 0 0 0-2.43-3.898 4.315 4.315 0 0 0-.722-.277 4.342 4.342 0 0 0-3.793.704 4.358 4.358 0 0 0-1.486 2.02A4.333 4.333 0 0 0 7.66 8a4.321 4.321 0 0 0 1.37 3.165l-2.2 3.518a2.34 2.34 0 1 0 1.469.82l3.075-4.917A2.658 2.658 0 0 1 9.34 8a2.66 2.66 0 1 1 5.246.625Zm6.799 6.438a4.359 4.359 0 0 0-1.892-1.92 4.358 4.358 0 0 0-3.434-.238l-2.188-3.499a2.35 2.35 0 0 1-1.424.892l3.078 4.92a2.643 2.643 0 0 1 1.975-.878 2.66 2.66 0 1 1-1.874 4.548l-1.184 1.192a4.34 4.34 0 0 0 6.943-5.017ZM9.16 17a2.67 2.67 0 0 1-.136.84 2.66 2.66 0 1 1-3.514-3.31l-.625-1.559a4.36 4.36 0 0 0-2.638 3.162 4.36 4.36 0 0 0 .386 2.84 4.36 4.36 0 0 0 1.806 1.846 4.322 4.322 0 0 0 1.651.502l.014.001a4.387 4.387 0 0 0 1.549-.138 4.344 4.344 0 0 0 3.106-3.344h4.556a2.341 2.341 0 1 0 0-1.68h-6.29a2.665 2.665 0 0 1 .135.84Zm9 0a.66.66 0 1 1-1.32 0 .66.66 0 0 1 1.32 0Zm-11.475.634a.66.66 0 1 0-.37-1.267.66.66 0 0 0 .37 1.267ZM8.74 16.16h-.054l.007.018.047-.018ZM12 8.66a.66.66 0 1 0 0-1.32.66.66 0 0 0 0 1.32ZM14.34 8a2.334 2.334 0 0 1-1.11 1.992A2.34 2.34 0 1 1 14.34 8Z" />
  </SvgIcon>
)

export const WarningIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7c-.696 0-1.261.565-1.261 1.261v4.958a1.261 1.261 0 1 0 2.522 0V8.261c0-.696-.564-1.261-1.26-1.261ZM12 15.742a1.26 1.26 0 1 0 0 2.52 1.26 1.26 0 0 0 0-2.52ZM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      fill="#EB5757"
    />
  </svg>
)
export const InformationIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-.879-8.937c-.172.411-.258.963-.258 1.656 0 0 0 .778.938.778.789 0 .836-.778.836-.778.01-.75.187-1.32.531-1.711l.96-.945c.793-.823 1.188-1.66 1.188-2.508 0-.953-.294-1.695-.882-2.227-.584-.53-1.399-.902-2.446-.902a3.673 3.673 0 0 0-2.453.91c-.614.537-.937 1.124-.937 2.188 0 0 .029.815.865.815.783 0 .983-.444 1.033-.815.05-.371.186-.766.457-1.016.276-.255.587-.39 1.035-.39.469 0 .823.13 1.063.39.245.255.367.628.367 1.117 0 .37-.104.714-.313 1.031-.135.209-.458.56-.968 1.055-.505.49-.844.94-1.016 1.352Zm-.101 3.344c-.193.187-.29.434-.29.742 0 .286.092.526.274.718.187.193.453.362.797.362.344 0 .61-.169.797-.362a.99.99 0 0 0 .28-.718.995.995 0 0 0-.288-.735 1.064 1.064 0 0 0-.79-.318 1.07 1.07 0 0 0-.78.31Z"
      fill="#4388FF"
    />
  </svg>
)

export const UploadIcon = (props: any) => (
  <svg width={56} height={56} fill="none" {...props}>
    <rect width={56} height={56} fill="#F1F7FF" rx={4} />
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M19 19a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1H19Zm11.777 2.514a2.195 2.195 0 1 0 0 4.39 2.195 2.195 0 0 0 0-4.39Zm-11.029 12.04 3.941-7.905a1.289 1.289 0 0 1 2.202-.175l3.603 5.043a.967.967 0 0 0 1.462.13l.897-.874a1.289 1.289 0 0 1 1.965.197l2.39 3.509a.644.644 0 0 1-.533 1.007h-15.35a.645.645 0 0 1-.577-.932Z"
      clipRule="evenodd"
    />
  </svg>
)

export const UploadIconError = (props: any) => (
  <svg width={56} height={56} fill="none" {...props}>
    <rect width={56} height={56} fill="#FCCED4" rx={4} />
    <path
      fill="#EB5757"
      fillRule="evenodd"
      d="M19 19a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V20a1 1 0 0 0-1-1H19Zm11.777 2.514a2.195 2.195 0 1 0 0 4.39 2.195 2.195 0 0 0 0-4.39Zm-11.029 12.04 3.941-7.905a1.289 1.289 0 0 1 2.202-.175l3.603 5.043a.967.967 0 0 0 1.462.13l.897-.874a1.289 1.289 0 0 1 1.965.197l2.39 3.509a.644.644 0 0 1-.533 1.007h-15.35a.645.645 0 0 1-.577-.932Z"
      clipRule="evenodd"
    />
  </svg>
)

export const WarningTriangleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.47012 20.5038L19.5301 20.5038C21.0701 20.5038 22.0301 18.8338 21.2601 17.5038L13.7301 4.49378C12.9601 3.16378 11.0401 3.16378 10.2701 4.49378L2.74012 17.5038C1.97012 18.8338 2.93012 20.5038 4.47012 20.5038ZM12.0001 13.5038C11.4501 13.5038 11.0001 13.0538 11.0001 12.5038L11.0001 10.5038C11.0001 9.95378 11.4501 9.50378 12.0001 9.50378C12.5501 9.50378 13.0001 9.95378 13.0001 10.5038L13.0001 12.5038C13.0001 13.0538 12.5501 13.5038 12.0001 13.5038ZM13.0001 16.5038C13.0001 17.0561 12.5524 17.5038 12.0001 17.5038C11.4478 17.5038 11.0001 17.0561 11.0001 16.5038C11.0001 15.9515 11.4478 15.5038 12.0001 15.5038C12.5524 15.5038 13.0001 15.9515 13.0001 16.5038Z"
        fill={props.fill || '#F0C74A'}
      />
    </SvgIcon>
  )
}

export const WarningBlueIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      d="M10.739 15.971a1.261 1.261 0 1 0 2.522 0v-4.958a1.261 1.261 0 1 0-2.522 0v4.958ZM12 8.491a1.26 1.26 0 1 1 0-2.52 1.26 1.26 0 0 1 0 2.52Z"
    />
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M22 12.002c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10Zm-1.68 0a8.32 8.32 0 1 0-16.64 0 8.32 8.32 0 0 0 16.64 0Z"
      clipRule="evenodd"
    />
  </svg>
)

export const WarningBlueIcon1 = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM10.74 7.63a1.26 1.26 0 1 0 2.52 0 1.26 1.26 0 0 0-2.52 0Zm1.26 10a1.261 1.261 0 0 1-1.261-1.26V11.41a1.261 1.261 0 1 1 2.522 0v4.958c0 .697-.565 1.261-1.261 1.261Z"
      clipRule="evenodd"
    />
  </svg>
)
export const KycIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g
      fill="#4388FF"
      fillRule="evenodd"
      clipPath="url(#KycIcon)"
      clipRule="evenodd"
    >
      <path d="M10.127 10.107a2.965 2.965 0 1 1 3.747-4.597 2.965 2.965 0 0 1-3.747 4.597Zm-.543 1.68c-.809 0-1.635.386-2.266.939l-.062.055c-.636.582-1.12 1.393-1.12 2.251v2.36c0 .768.623 1.39 1.39 1.39h8.95a1.39 1.39 0 0 0 1.39-1.39v-2.36c0-.853-.464-1.662-1.087-2.246l-.022-.022c-.622-.573-1.452-.976-2.279-.976l-4.894-.001Zm4.894 1.679H9.584c-.422 0-.879.177-1.23.476a1.71 1.71 0 0 0-.02.018c-.337.295-.54.676-.54 1.072v1.458a.61.61 0 0 0 .61.61h7.182a.61.61 0 0 0 .61-.61v-1.458c0-.348-.196-.737-.537-1.052l-.008-.008c-.345-.315-.781-.506-1.173-.506ZM12 9.094a1.285 1.285 0 1 0 0-2.57 1.285 1.285 0 0 0 0 2.57ZM7.873 2a.84.84 0 0 1 0 1.68H3.928a.25.25 0 0 0-.25.25v3.95A.84.84 0 1 1 2 7.88V3a1 1 0 0 1 1-1h4.873Z" />
      <path d="M7.873 22a.84.84 0 0 0 0-1.68H3.928a.25.25 0 0 1-.25-.25v-3.95a.84.84 0 1 0-1.678 0V21a1 1 0 0 0 1 1h4.873ZM16.124 2a.84.84 0 0 0 0 1.68h3.944a.25.25 0 0 1 .25.25v3.95a.84.84 0 1 0 1.678 0V3a1 1 0 0 0-1-1h-4.872ZM16.123 22a.84.84 0 0 1 0-1.68h3.945a.25.25 0 0 0 .25-.25v-3.95a.84.84 0 1 1 1.678 0V21a1 1 0 0 1-1 1h-4.873Z" />
    </g>
    <defs>
      <clipPath id="KycIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const KycIcon1 = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g
      fill="#717275"
      fillRule="evenodd"
      clipPath="url(#KycIcon1)"
      clipRule="evenodd"
    >
      <path d="M10.127 10.107a2.965 2.965 0 1 1 3.747-4.597 2.965 2.965 0 0 1-3.747 4.597Zm-.543 1.68c-.809 0-1.635.386-2.266.939l-.062.055c-.636.582-1.12 1.393-1.12 2.251v2.36c0 .768.623 1.39 1.39 1.39h8.95a1.39 1.39 0 0 0 1.39-1.39v-2.36c0-.853-.464-1.662-1.087-2.246l-.022-.022c-.622-.573-1.452-.976-2.279-.976l-4.894-.001Zm4.894 1.679H9.584c-.422 0-.879.177-1.23.476a1.71 1.71 0 0 0-.02.018c-.337.295-.54.676-.54 1.072v1.458a.61.61 0 0 0 .61.61h7.182a.61.61 0 0 0 .61-.61v-1.458c0-.348-.196-.737-.537-1.052l-.008-.008c-.345-.315-.781-.506-1.173-.506ZM12 9.094a1.285 1.285 0 1 0 0-2.57 1.285 1.285 0 0 0 0 2.57ZM7.873 2a.84.84 0 0 1 0 1.68H3.928a.25.25 0 0 0-.25.25v3.95A.84.84 0 1 1 2 7.88V3a1 1 0 0 1 1-1h4.873Z" />
      <path d="M7.873 22a.84.84 0 0 0 0-1.68H3.928a.25.25 0 0 1-.25-.25v-3.95a.84.84 0 1 0-1.678 0V21a1 1 0 0 0 1 1h4.873ZM16.124 2a.84.84 0 0 0 0 1.68h3.944a.25.25 0 0 1 .25.25v3.95a.84.84 0 1 0 1.678 0V3a1 1 0 0 0-1-1h-4.872ZM16.123 22a.84.84 0 0 1 0-1.68h3.945a.25.25 0 0 0 .25-.25v-3.95a.84.84 0 1 1 1.678 0V21a1 1 0 0 1-1 1h-4.873Z" />
    </g>
    <defs>
      <clipPath id="KycIcon1">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const KybIcon = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#KybIcon)">
      <path
        fill="#4388FF"
        fillRule="evenodd"
        d="M4.8 4.8V8H7V4.8H4.8Zm0 4.9H7V13H4.8V9.7Zm3.9 0V13h2.5V9.7H8.7Zm-3.9 5H7v4.5H4.8v-4.5Zm3.9 0v4.5h2.5v-4.5H8.7Zm0-9.9V8h2.5V4.8H8.7ZM4 3a1 1 0 0 0-1 1v17h10V4a1 1 0 0 0-1-1H4Zm15.3 5.7h-4.6V7H20a1 1 0 0 1 1 1v13h-6.3v-1.7h4.6V8.7Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="KybIcon">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const KybIcon1 = (props: any) => (
  <svg width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#KybIcon1)">
      <path
        fill="#717275"
        fillRule="evenodd"
        d="M4.8 4.8V8H7V4.8H4.8Zm0 4.9H7V13H4.8V9.7Zm3.9 0V13h2.5V9.7H8.7Zm-3.9 5H7v4.5H4.8v-4.5Zm3.9 0v4.5h2.5v-4.5H8.7Zm0-9.9V8h2.5V4.8H8.7ZM4 3a1 1 0 0 0-1 1v17h10V4a1 1 0 0 0-1-1H4Zm15.3 5.7h-4.6V7H20a1 1 0 0 1 1 1v13h-6.3v-1.7h4.6V8.7Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="KybIcon1">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export const EditIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <g clipPath="url(#aEditIcon)">
      <path
        fill="#717275"
        d="M22 16.32 23.68 18l-9.44 9.32h-1.56v-1.56L22 16.32ZM25.66 11c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29Zm-3.6 3.19L11.293 24.957a1 1 0 0 0-.293.707V29h3.336a1 1 0 0 0 .707-.293L25.81 17.94l-3.75-3.75Z"
      />
    </g>
    <defs>
      <clipPath id="aEditIcon">
        <path fill="#fff" d="M8 8h24v24H8z" />
      </clipPath>
    </defs>
  </svg>
)

export const EditGreyIcon = (props: any) => (
  <svg width={40} height={40} fill="none" {...props}>
    <g clipPath="url(#aEditGreyIcon)">
      <g clipPath="url(#bEditGreyIcon)">
        <path
          fill="#C8C9CC"
          d="M22 16.32 23.68 18l-9.44 9.32h-1.56v-1.56L22 16.32ZM25.66 11c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29Zm-3.6 3.19L11.293 24.957a1 1 0 0 0-.293.707V29h3.336a1 1 0 0 0 .707-.293L25.81 17.94l-3.75-3.75Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="aEditGreyIcon">
        <rect width={40} height={40} fill="#fff" rx={8} />
      </clipPath>
      <clipPath id="bEditGreyIcon">
        <path fill="#fff" d="M8 8h24v24H8z" />
      </clipPath>
    </defs>
  </svg>
)

export const BlockpassFooterIcon = (props: any) => (
  <svg width={147} height={24} fill="none" {...props}>
    <path
      fill="#4388FF"
      fillRule="evenodd"
      d="M32.533 9.012c-.34.803-.51 1.67-.51 2.6 0 .93.17 1.796.51 2.6a6.49 6.49 0 0 0 1.413 2.1 6.45 6.45 0 0 0 2.16 1.404c.838.338 1.761.507 2.769.507.996 0 1.916-.17 2.76-.507a6.521 6.521 0 0 0 2.177-1.404 6.425 6.425 0 0 0 1.421-2.1c.34-.803.51-1.67.51-2.6 0-.93-.17-1.797-.51-2.6a6.424 6.424 0 0 0-1.421-2.1 6.52 6.52 0 0 0-2.177-1.404C40.792 5.17 39.87 5 38.875 5c-1.008 0-1.93.169-2.769.507a6.449 6.449 0 0 0-2.16 1.403 6.49 6.49 0 0 0-1.413 2.101Zm-9.856 6.104V5.35h-3.22v12.524h7.081v-2.758h-3.86ZM3.457 5.35h4.798c1.139 0 2.004.277 2.595.83.592.554.888 1.351.888 2.392 0 .631-.113 1.155-.337 1.57-.225.415-.567.767-1.027 1.055.46.088.852.224 1.175.407.323.182.586.407.788.672.203.266.348.565.436.897.087.332.131.687.131 1.063 0 .587-.101 1.108-.304 1.562a3.169 3.169 0 0 1-.854 1.146 3.64 3.64 0 0 1-1.34.697 6.27 6.27 0 0 1-1.774.233H3.457V5.35Zm3.81 4.916h-.591V7.84h.591c1.008 0 1.512.404 1.512 1.212 0 .809-.504 1.213-1.512 1.213Zm.115 5.083h-.706v-2.658h.706c.81 0 1.391.106 1.742.316.35.21.526.548.526 1.013 0 .465-.176.803-.526 1.013-.35.21-.931.316-1.742.316Zm28.013-3.737c0 .498.093.958.279 1.379a3.413 3.413 0 0 0 1.865 1.819c.421.171.868.257 1.339.257a3.519 3.519 0 0 0 2.456-.98 3.369 3.369 0 0 0 1.043-2.475 3.369 3.369 0 0 0-1.043-2.475 3.518 3.518 0 0 0-2.456-.98c-.471 0-.918.086-1.34.258a3.413 3.413 0 0 0-1.864 1.819c-.186.42-.28.88-.28 1.378Zm25.944-2.076c-.744-.92-1.664-1.38-2.76-1.38-.482 0-.928.09-1.339.267-.41.177-.764.418-1.06.722a3.33 3.33 0 0 0-.698 1.088c-.17.421-.255.875-.255 1.362 0 .498.085.958.255 1.379a3.311 3.311 0 0 0 1.766 1.827c.406.177.844.266 1.315.266 1.03 0 1.955-.443 2.776-1.33v3.854l-.328.117a9.441 9.441 0 0 1-1.38.39 6.614 6.614 0 0 1-1.265.125 6.32 6.32 0 0 1-2.457-.49 6.416 6.416 0 0 1-2.07-1.379 6.859 6.859 0 0 1-1.437-2.11c-.362-.813-.543-1.702-.543-2.665 0-.964.178-1.847.534-2.65a6.596 6.596 0 0 1 1.43-2.076A6.531 6.531 0 0 1 55.9 5.491a6.42 6.42 0 0 1 2.481-.49c.493 0 .978.053 1.454.158.477.105.978.268 1.503.49v3.887ZM75.682 5.35l-3.927 5.165V5.35h-3.22v12.524h3.22v-5.432l4.19 5.432h4.173l-5.372-6.595 4.912-5.93h-3.976Zm13.716 5.746h1.068c1.183 0 1.775-.52 1.775-1.561 0-1.04-.592-1.561-1.775-1.561h-1.068v3.122Zm-3.222 6.778h3.22V13.72h1.906c1.39 0 2.456-.365 3.195-1.096.74-.731 1.11-1.76 1.11-3.09 0-1.328-.37-2.358-1.11-3.09-.739-.73-1.804-1.095-3.195-1.095h-5.126v12.524Zm21.817-4.65-1.446-4.17-1.445 4.17h2.891Zm-3.742 2.474h4.601l.739 2.176h3.434L108.309 5.35h-3.516l-4.715 12.524h3.434l.739-2.176Zm21.617-7.142a3.966 3.966 0 0 0-1.051-.64 2.768 2.768 0 0 0-1.019-.208c-.416 0-.756.1-1.018.3a.935.935 0 0 0-.395.78c0 .222.066.404.197.548.132.144.304.269.518.374.214.105.455.197.723.274.268.078.534.16.797.25 1.051.354 1.821.827 2.308 1.42.488.592.731 1.364.731 2.316 0 .643-.107 1.224-.32 1.744-.214.521-.526.967-.937 1.338-.41.37-.914.659-1.511.863-.597.205-1.273.308-2.029.308-1.567 0-3.018-.47-4.354-1.412l1.38-2.625c.482.432.958.753 1.429.964.471.21.937.315 1.397.315.526 0 .917-.121 1.175-.365.257-.244.386-.52.386-.83 0-.189-.033-.352-.099-.49a1.062 1.062 0 0 0-.328-.383 2.652 2.652 0 0 0-.6-.324c-.247-.1-.545-.21-.896-.332-.416-.133-.824-.28-1.224-.44a3.867 3.867 0 0 1-1.068-.64 2.96 2.96 0 0 1-.755-1.004c-.192-.404-.288-.917-.288-1.537 0-.62.101-1.182.304-1.686.203-.503.488-.935.854-1.295.367-.36.816-.64 1.348-.839a5.04 5.04 0 0 1 1.782-.299 7.73 7.73 0 0 1 1.923.257 8.417 8.417 0 0 1 1.922.756l-1.282 2.542Zm14.199-.64c.35.138.701.352 1.051.64l1.282-2.542a8.417 8.417 0 0 0-1.922-.756 7.73 7.73 0 0 0-1.923-.257c-.657 0-1.251.1-1.782.299-.532.2-.981.479-1.348.839-.366.36-.651.792-.854 1.295a4.475 4.475 0 0 0-.304 1.686c0 .62.096 1.133.288 1.537.191.404.443.739.755 1.005.313.265.669.479 1.068.64.4.16.808.306 1.224.44.351.121.649.232.896.331.246.1.446.208.6.324.153.117.262.244.328.383.066.138.099.301.099.49 0 .31-.129.586-.386.83-.258.244-.649.365-1.175.365-.46 0-.926-.105-1.397-.315-.471-.21-.947-.532-1.429-.964l-1.38 2.625c1.336.941 2.787 1.412 4.354 1.412.756 0 1.432-.103 2.029-.308a4.301 4.301 0 0 0 1.511-.863c.411-.371.723-.817.937-1.338.213-.52.32-1.101.32-1.744 0-.952-.243-1.724-.731-2.317-.487-.592-1.257-1.066-2.308-1.42a19.188 19.188 0 0 0-.797-.249 4.428 4.428 0 0 1-.723-.274 1.723 1.723 0 0 1-.518-.374.784.784 0 0 1-.197-.548c0-.321.132-.581.395-.78.262-.2.602-.3 1.018-.3.329 0 .668.07 1.019.208Z"
      clipRule="evenodd"
    />
  </svg>
)
